(function ($) {
    'use strict';


    var canvas_width = cmToPixel(100),
        canvas_height = cmToPixel(100),
        uniqId = fabric.Object.__uid;

    const fontFamilySelect = document.getElementById('fontFamilySelect');
    const textSizeInput = document.getElementById('textSizeInput');
    const textColorInput = document.getElementById('bgColorPicker');
    const boldCheckbox = document.getElementById('boldCheckbox');
    const italicCheckbox = document.getElementById('italicCheckbox');
    const underlineCheckbox = document.getElementById('underlineCheckbox');
    const optionMenu = document.querySelector(".select-menu"),
      selectBtn = optionMenu.querySelector(".select-btn"),
      options = optionMenu.querySelectorAll(".option"),
      sBtn_text = optionMenu.querySelector(".sBtn-text");

    // FONT DROPDOWN - options are now SVG images (<img class="option-text"
    // value="...">), so there is no option text to read. The font is taken
    // from the option's `value` attribute and matched (case-insensitively,
    // e.g. value="oswald" -> "Oswald") against the hidden <select>. The
    // button label comes from that select option's text, which also gives
    // the friendly name "Cooper Black" for the "Coustard" font family.
    function resolveFontOption(fontValue) {
      const wanted = String(fontValue || '').toLowerCase();
      return Array.prototype.find.call(fontFamilySelect.options, function (opt) {
        return opt.value.toLowerCase() === wanted;
      }) || null;
    }
    function getFontDisplayName(fontValue) {
      const opt = resolveFontOption(fontValue);
      return opt ? opt.textContent.trim() : fontValue;
    }
    var scaleXdata = "";
    var scaleYdata = "";

    // KP FEATURE - text stacking direction. New text lines normally
    // stack DOWNWARD (each new line below the previous one). Once a
    // new line would overflow past the bottom of the canvas, we flip
    // to stacking UPWARD instead - the overflowing line is placed
    // directly above the very FIRST text block on the canvas, and
    // every line added after that continues stacking above the
    // previous one (i.e. above whichever line was added last), with
    // no bounce back to downward stacking. Reset to 'down' whenever
    // the text stack is empty (see addText() below), so a fresh stack
    // always starts by filling downward again.
    var textStackDirection = 'down';

    var bgImage = "";

    // KP FIX - tracks which custom corner control (deleteControl /
    // resizeControl / moveControl) the mouse is currently hovering over,
    // so the round border/outline drawn around each icon (see
    // renderIcon() and renderMoveIcon() below) can be shown ONLY while
    // hovering that specific control, instead of being drawn all the
    // time. Null means "not hovering any custom control".
    var hoveredControlKey = null;

    var canvas = new fabric.Canvas("bg_canvas", {
        left: cmToPixel(2),
        top: cmToPixel(2),
        preserveObjectStacking: true,
        uniformScaling: true,
        uniScaleTransform: true,
        enableRetinaScaling: true,
            });
    // canvas.uniformScaling = false;
    canvas.allowTouchScrolling = true;
    // multi select false
    canvas.selectionKey = null;

    // multi select false on mobile
    canvas.selection = false;

    // enable/disable size slider
    $('#imagescale , #textSizeInput').prop('disabled', true);


    // KP FIX - sticker disappearing during a fast drag (both wall view and
    // sticker view). Fabric.js's canvas has a render optimization called
    // skipOffscreen (true by default, was never set here) that skips
    // drawing an object entirely if it judges the object's bounding box to
    // be fully outside the visible canvas. During a very fast drag that
    // check can misjudge the object as offscreen for a frame (the
    // transform hasn't fully settled yet relative to when the check runs),
    // so Fabric skips rendering it that frame - which looks like the
    // sticker vanishing until the drag slows down or stops. Disabling it
    // makes Fabric always attempt to render the active object regardless,
    // so it stays visible and keeps up with the cursor/finger no matter
    // how fast it's moved.
    canvas.skipOffscreen = false;

    // SM - suppress iOS Safari native gesture events (pinch-zoom, double-tap
    // zoom) on the canvas element. These fire before Fabric.js sees touch
    // events and would otherwise scale the <canvas> directly.
    var canvasEl = document.getElementById('bg_canvas');
    if (canvasEl) {
        canvasEl.addEventListener('gesturestart', function (e) { e.preventDefault(); });
        canvasEl.addEventListener('gesturechange', function (e) { e.preventDefault(); });
        canvasEl.addEventListener('gestureend', function (e) { e.preventDefault(); });
    }

    canvas.setWidth(canvas_width).setHeight(canvas_height);
    addRulers(canvas_width, canvas_height);

    let holderHeightTmp = $('.bg-canvas-holder').outerWidth();
    var holderHeight = holderHeightTmp;
    $('.bg-canvas-holder').css('height', holderHeight + 'px');

    // KP FIX - mobile blur fix: opening/closing the on-screen keyboard
    // fires a 'resize' event that only changes the window HEIGHT (the
    // layout viewport shrinks to make room for the keyboard), not the
    // WIDTH. The old handler below ran the full canvas reset on every
    // one of those events too - resetCanvasSize() briefly sets the
    // canvas to its full intrinsic print-resolution size
    // (canvas.setDimensions to the raw cm pixel size) before scaling
    // it back down to fit the container. Doing that repeatedly while
    // the user types (each keystroke can nudge the keyboard/viewport)
    // is what showed up as the canvas, dimension controls, and text
    // all going blurry/fuzzy mid-typing. Now we only run the resize
    // logic when the available WIDTH actually changed, and debounce
    // it so a burst of resize events (e.g. keyboard show/hide
    // animation) only triggers one recalculation after things settle.
    var lastWindowWidth = $(window).width();
    var canvasResizeDebounce = null;
    $(window).on('resize', function () {
        var newWindowWidth = $(window).width();
        if (newWindowWidth === lastWindowWidth) {
            // Height-only change (mobile keyboard open/close) - ignore.
            return;
        }
        lastWindowWidth = newWindowWidth;

        clearTimeout(canvasResizeDebounce);
        canvasResizeDebounce = setTimeout(function () {
            let holderHeightTmp = $('.bg-canvas-holder').outerWidth();
            var holderHeight = holderHeightTmp;
            $('.bg-canvas-holder').css('height', holderHeight + 'px');

            var cmDataNew = 100;
            var cmDataNewPixel = cmToPixel(cmDataNew);
            resetCanvasSize(canvas, { 'width': cmDataNewPixel, 'height': cmDataNewPixel });
        }, 150);
    });

    // KP FIX - scroll canvas vs drag object conflict on touch devices.
    // Toggle a "scroll-canvas" class on .bg-editor-canvas based on
    // whether any object is currently active:
    // - no object active -> add "scroll-canvas" (page/canvas can scroll
    //   on touch).
    // - an object active -> remove "scroll-canvas" (touch drags the
    //   object instead).
    // The actual scroll-enabling CSS (e.g. touch-action) should be
    // defined on .bg-editor-canvas.scroll-canvas in the stylesheet.
    var $bgEditorCanvas = $('.bg-editor-canvas');

    function updateScrollCanvasClass() {
        if (canvas.getActiveObject()) {
            $bgEditorCanvas.removeClass('scroll-canvas');
        } else {
            $bgEditorCanvas.addClass('scroll-canvas');
        }
    }
    // start in "scrollable" state - nothing is selected on load
    updateScrollCanvasClass();

    canvas.on('selection:created', updateScrollCanvasClass);
    canvas.on('selection:updated', updateScrollCanvasClass);
    canvas.on('selection:cleared', updateScrollCanvasClass);

    // KP FIX - border-on-hover for the custom delete/resize/move icons.
    // On every mouse move over the canvas, check whether the pointer is
    // sitting on top of one of the active object's custom controls
    // (using fabric's own corner hit-testing, _findTargetCorner), and
    // remember which one via hoveredControlKey. renderIcon() and
    // renderMoveIcon() read this value to decide whether to draw the
    // round border/outline - only while the matching control is
    // hovered, never by default. Only re-render when the hovered
    // control actually changes, so this doesn't redraw the canvas on
    // every single pixel of mouse movement.
    canvas.on('mouse:move', function (opt) {
        var activeObject = canvas.getActiveObject();
        var nextHoveredKey = null;

        if (activeObject && typeof activeObject._findTargetCorner === 'function') {
            var pointer = canvas.getPointer(opt.e, true);
            var cornerKey = activeObject._findTargetCorner(pointer, fabric.util.isTouchEvent && fabric.util.isTouchEvent(opt.e));
            if (cornerKey === 'deleteControl' || cornerKey === 'resizeControl' || cornerKey === 'moveControl') {
                nextHoveredKey = cornerKey;
            }
        }

        if (nextHoveredKey !== hoveredControlKey) {
            hoveredControlKey = nextHoveredKey;
            canvas.requestRenderAll();
        }
    });

    // KP FIX - make sure a stale hover state (e.g. border left showing)
    // doesn't linger once the object is deselected or the pointer
    // leaves the canvas entirely.
    canvas.on('selection:cleared', function () {
        if (hoveredControlKey !== null) {
            hoveredControlKey = null;
            canvas.requestRenderAll();
        }
    });
    canvas.on('mouse:out', function () {
        if (hoveredControlKey !== null) {
            hoveredControlKey = null;
            canvas.requestRenderAll();
        }
    });

    // KP - when nothing is selected: keep showing the size of the last
    // active object (e.g. after clicking "Done" on a text box) instead
    // of hiding the "Your Sticker Preview" size block. Only fall back
    // to the default image size if the canvas has been fully cleared
    // of objects.
    canvas.on('selection:cleared', function () {
        if (typeof resetPreviewSizeHeading !== 'function') {
            return;
        }
        var remainingObjects = canvas.getObjects().filter(function (obj) {
            return obj !== bgData;
        });
        if (remainingObjects.length === 0) {
            resetPreviewSizeHeading();
        }
        // otherwise leave the heading as-is, still showing the last
        // active object's size
    });

    canvas.on('object:added', function (currentObj) {
        removeObjectControls(currentObj.target);
        //kk object overlap check 9-6-26 
        checkObjectOverlap();
        //kk object overlap check 9-6-26 

        // check canvas is empty or not 
        updateCanvasEmptyState();

        // KP FIX - if an object is already active when a new image/text
        // is added, leave the scroll-canvas class alone (do nothing). If
        // nothing is active, make sure "scroll-canvas" is present.
        if (!canvas.getActiveObject()) {
            $bgEditorCanvas.addClass('scroll-canvas');
        }

        // updateModifications();
    });
    canvas.on('object:modified', function (currentObj) {
         //kk object overlap check 9-6-26 
        checkObjectOverlap();
        //kk object overlap check 9-6-26 
        // updateModifications();
    });

    // Restrict objects from moving outside the canvas
    canvas.on('object:moving', function (e) {
        var obj = e.target;
        // if object is too big ignore
        if (obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width) {
            return;
        }
        obj.setCoords();

        // KP FIX - wall-view <-> sticker-view toggle bug: constrain
        // against the actual VISIBLE canvas box, not the raw
        // canvas.width/height (the full <canvas> element). Wall-view
        // zooms out and centers the logical 100x100cm canvas via
        // applyCenteredZoom(), which leaves empty padding around it
        // (viewportTransform's tx/ty). The old checks below compared
        // screen-space bounding rects against 0..canvas.width/height,
        // i.e. the full container including that padding, so an object
        // could be dragged into the padding area in wall-view - a
        // position that is actually outside the real 100x100cm canvas.
        // Since object left/top are logical (zoom-independent)
        // coordinates, that same position then renders outside the
        // canvas in sticker-view, which has no padding (tx/ty = 0) and
        // a larger zoom. Using the real visible box here keeps objects
        // inside the true canvas bounds in every view.
        var vt = canvas.viewportTransform;
        var zoom = vt[0];
        var boxLeft = vt[4];
        var boxTop = vt[5];
        var boxRight = boxLeft + (canvas_width * zoom);
        var boxBottom = boxTop + (canvas_height * zoom);

        // top-left  corner
        if (obj.getBoundingRect().top < boxTop || obj.getBoundingRect().left < boxLeft) {
            var topVal = Math.max(obj.top, obj.top + (boxTop - obj.getBoundingRect().top) / zoom);
            var leftVal = Math.max(obj.left, obj.left + (boxLeft - obj.getBoundingRect().left) / zoom);
            obj.top = (topVal < 0) ? 1 : topVal;
            obj.left = (leftVal < 0) ? 1 : leftVal;
            // KP FIX - refresh coords immediately after the top-left
            // correction above, before reading the bounding rect again
            // below. On a fast drag the right/bottom check otherwise runs
            // against the pre-correction position, which can produce an
            // incorrect clamp and let the object's position jump/overshoot
            // instead of tracking the cursor smoothly.
            obj.setCoords();
        }
        var boundingRect = obj.getBoundingRect();
        var realSizeData = calculateRealSize(canvas);
        var canHeight = cmToPixel(realSizeData.height);
        var canWidth = cmToPixel(realSizeData.width);

        if (boundingRect.left + boundingRect.width > boxRight) {
            // obj.left/width are logical (zoom-independent), so clamp
            // directly in that space instead of the old obj.zoomX-based
            // math (obj.zoomX was never set, so that branch was NaN).
            obj.left = (canWidth - obj.getScaledWidth()) - 1;
            obj.setCoords();
        }

        if (boundingRect.top + boundingRect.height > boxBottom) {
            obj.top = (canHeight - obj.getScaledHeight()) - 1;
            obj.setCoords();
        }



        //kk object overlap check 9-6-26 
        checkObjectOverlap();
        //kk object overlap check 9-6-26 
    });

    // Restrict objects from enlarge more than canvas
    // var left1 = 0;
    // var top1 = 0;
    // var scale1x = 0;
    // var scale1y = 0;
    // var width1 = 0;
    // var height1 = 0;
    // var textSizeData = "";
    var scalingSnapshots = new Map();
    let previousScaleY = null;
    canvas.on('object:scaling', function (e) {
        var obj = e.target;

        // KP FIX - aspect-ratio-preserving 100cm clamp.
        // Old logic tried to lock whichever axis (X or Y) hit 100cm first
        // and freeze the OTHER axis independently at "whatever obj.scaleY
        // happened to be that frame". But by the time a frame is checked,
        // the pointer has usually already moved slightly past the exact
        // boundary (mouse/touch events don't land exactly on 100cm), so
        // the frozen axis got locked to a slightly overshot value while
        // the capped axis got locked to the mathematically exact value -
        // two different scale factors, permanently mismatched for the
        // rest of the drag. That mismatch is the "stretched, ratio no
        // longer matches original" bug.
        //
        // Fix: scaling here is always uniform (scaleX === scaleY) - every
        // other resize path in this file (sliders, width/height inputs)
        // sets both to the same value. So there is only ever ONE scale
        // factor to clamp, not two independent ones. We compute the max
        // uniform scale that keeps BOTH width and height within 100cm and
        // clamp scaleX/scaleY to that same number together, so the
        // object's original aspect ratio is always preserved, both while
        // hitting the limit and for the remainder of the drag.
        var maxPx = cmToPixel(100);
        var maxAllowedScale = maxPx / Math.max(obj.width, obj.height);

        var newScale = Math.min(obj.scaleX, obj.scaleY, maxAllowedScale);

        obj.set({
            scaleX: newScale,
            scaleY: newScale,
        });
        previousScaleY = obj.scaleY;
         obj.setCoords();

        //kk object overlap check 9-6-26 
        checkObjectOverlap();
        //kk object overlap check 9-6-26 

    });
    
    canvas.on('object:scaling', function (e) {
        var obj = e.target;
        var objId = obj.uniqId || obj.__uid;
        if (!objId) {
            obj.uniqId = ++uniqId;
            objId = obj.uniqId;
        }

        obj.setCoords();
        var brNew = obj.getBoundingRect();

        // KP - small tolerance so reaching exactly 100cm (canvas edge) isn't treated as overflow and reverted to the previous (slightly smaller, e.g. 99cm) frame
        // KP FIX - tolerance must be computed in real-world (cm) space, not
        // a fixed screen-pixel amount. brNew is measured AFTER the current
        // canvas zoom is applied, and sticker-view's zoom (~getBaseScale())
        // is roughly 3x larger than wall-view's (getBaseScale() * 0.35).
        // A fixed 0.5px tolerance therefore represented a much smaller real
        // -world allowance in sticker view than in wall view, so sticker
        // view reverted just before reaching 100cm (stopping at ~99) while
        // wall view had enough slack to reach 100 cleanly. Scaling the
        // tolerance by the current zoom keeps it equivalent to the same
        // ~0.5cm allowance in every view.
        var currentZoom = (canvas.viewportTransform && canvas.viewportTransform[0]) ? canvas.viewportTransform[0] : 1;
        var toleranceCm = 0.5;
        var tolerance = cmToPixel(toleranceCm) * currentZoom;

        // KP FIX - same wall-view/sticker-view toggle bug as
        // 'object:moving' above: bound against the real visible canvas
        // box (accounting for the pan offset applied when the view is
        // zoomed out/centered), not the raw 0..canvas.width/height. See
        // the full explanation in the 'object:moving' handler.
        var boxLeft = canvas.viewportTransform[4];
        var boxTop = canvas.viewportTransform[5];
        var boxRight = boxLeft + (canvas_width * currentZoom);
        var boxBottom = boxTop + (canvas_height * currentZoom);

        var snap = scalingSnapshots.get(objId);

        if (((brNew.width + brNew.left) >= boxRight + tolerance) || ((brNew.height + brNew.top) >= boxBottom + tolerance) || ((brNew.left < boxLeft - tolerance) || (brNew.top < boxTop - tolerance))) {
            if (snap) {
                textSizeInput.value = snap.textSizeData;
                if (obj.type == "i-text") {
                    obj.set({
                        fontSize: snap.textSizeData
                    });
                }
                obj.left = snap.left;
                obj.top = snap.top;
                obj.scaleX = snap.scaleX;
                obj.scaleY = snap.scaleY;
                obj.width = snap.width;
                obj.height = snap.height;
            }
        } else {
            scalingSnapshots.set(objId, {
                left: obj.left,
                top: obj.top,
                scaleX: obj.scaleX,
                scaleY: obj.scaleY,
                width: obj.width,
                height: obj.height,
                textSizeData: textSizeInput.value
            });
        }
    });

    // KP FIX - typing grows the IText box on every keystroke, but only
    // 'object:scaling' was checked against canvas bounds. Typed text could
    // silently sit past the edge (or right at it with a stale snapshot),
    // so a later font-size change had nothing valid to revert to.
    function clampTextToCanvasBounds(obj) {
        if (!obj || obj.type !== 'i-text') return;

        obj.setCoords();

        var vt = canvas.viewportTransform;
        var zoom = vt[0];
        var boxLeft = vt[4];
        var boxTop = vt[5];
        var boxRight = boxLeft + (canvas_width * zoom);
        var boxBottom = boxTop + (canvas_height * zoom);

        var br = obj.getBoundingRect();
        var overflowRight = (br.left + br.width) - boxRight;
        var overflowBottom = (br.top + br.height) - boxBottom;
        var overflowLeft = boxLeft - br.left;
        var overflowTop = boxTop - br.top;
        var maxOverflow = Math.max(overflowRight, overflowBottom, overflowLeft, overflowTop, 0);

        if (maxOverflow > 0) {
            // Shrink the fontSize directly (not width/height - Fabric
            // recomputes those from the text + fontSize anyway, so setting
            // them manually never sticks).
            var shrinkRatio = Math.min(
                (br.width - Math.max(overflowRight, overflowLeft, 0)) / br.width,
                (br.height - Math.max(overflowBottom, overflowTop, 0)) / br.height
            );
            shrinkRatio = Math.max(shrinkRatio, 0.1);

            var newFontSize = Math.max(Math.floor(obj.fontSize * shrinkRatio), 5);
            obj.set({ fontSize: newFontSize });
            obj.setCoords();

            if (canvas.getActiveObject() === obj) {
                textSizeInput.value = newFontSize;
            }
        }

        // Refresh the snapshot so the object:scaling revert logic always
        // compares against the CURRENT in-bounds state, not one from before
        // the user typed.
        var objId = obj.uniqId || obj.__uid;
        if (objId) {
            scalingSnapshots.set(objId, {
                left: obj.left, top: obj.top,
                scaleX: obj.scaleX, scaleY: obj.scaleY,
                width: obj.width, height: obj.height,
                textSizeData: obj.fontSize
            });
        }
    }

    canvas.on('text:changed', function (e) {
        clampTextToCanvasBounds(e.target);
        canvas.requestRenderAll();
    });

    //kk object overlap check 10-6-2026 - pixel perfact
    // KP FIX - generalized from "imageObj, textObj" to "objA, objB" so
    // this same pixel-perfect check can be reused for BOTH overlap
    // cases we warn about: text-over-photo AND text-over-text. The
    // logic itself never actually depended on one being an image and
    // the other being text - it just rasterizes each object into its
    // own offscreen canvas over the shared overlap region and compares
    // alpha channels.
     function hasPixelOverlap(objA, objB, alphaThreshold = 10) {

        const imgRect = objA.getBoundingRect(true);
        const txtRect = objB.getBoundingRect(true);

        const left = Math.floor(Math.max(imgRect.left, txtRect.left));
        const top = Math.floor(Math.max(imgRect.top, txtRect.top));

        const right = Math.ceil(
            Math.min(
                imgRect.left + imgRect.width,
                txtRect.left + txtRect.width
            )
        );

        const bottom = Math.ceil(
            Math.min(
                imgRect.top + imgRect.height,
                txtRect.top + txtRect.height
            )
        );

        const width = right - left;
        const height = bottom - top;

        if (width <= 0 || height <= 0) {
            return false;
        }

        const imgCanvas = document.createElement('canvas');
        imgCanvas.width = width;
        imgCanvas.height = height;

        const txtCanvas = document.createElement('canvas');
        txtCanvas.width = width;
        txtCanvas.height = height;

        const imgCtx = imgCanvas.getContext('2d');
        const txtCtx = txtCanvas.getContext('2d');

        imgCtx.translate(-left, -top);
        txtCtx.translate(-left, -top);

        objA.render(imgCtx);
        objB.render(txtCtx);

        const imgData = imgCtx.getImageData(
            0,
            0,
            width,
            height
        ).data;

        const txtData = txtCtx.getImageData(
            0,
            0,
            width,
            height
        ).data;

        for (let i = 3; i < imgData.length; i += 4) {

            if (
                imgData[i] > alphaThreshold &&
                txtData[i] > alphaThreshold
            ) {
                return true;
            }
        }

        return false;
    }
    
    // KP FIX - sets the overlap warning message. Tries a
    // '.overlap-warning-message' child first (in case #overlap-warning
    // wraps the text with an icon or other markup that shouldn't be
    // wiped out), and falls back to setting the element's own text if
    // no such child exists.
    function setOverlapWarning(message) {
        var $warning = $('#overlap-warning');
        var $msgEl = $warning.find('.overlap-warning-message');
        if ($msgEl.length) {
            $msgEl.text(message);
        } else {
            $warning.text(message);
        }
        $warning.show();
    }

    function checkObjectOverlap() {

        const objects = canvas.getObjects().filter(obj =>
            obj.visible &&
            obj.type !== 'line' &&
            obj.type !== 'group'
        );

        // KP FIX - the warning is only ever about TEXT overlapping
        // something (a photo, or other text), so we track which of the
        // two messages applies, and only ever act on pairs that include
        // at least one text object. A photo overlapping another photo,
        // for example, should never trigger this warning.
        let overlapMessage = null;

        outerLoop:
        for (let i = 0; i < objects.length; i++) {

            for (let j = i + 1; j < objects.length; j++) {

                const obj1 = objects[i];
                const obj2 = objects[j];

                if (obj1 === bgData || obj2 === bgData) {
                    continue;
                }

                const obj1IsText = obj1.type === 'i-text';
                const obj2IsText = obj2.type === 'i-text';

                // Not a text-involving pair at all - never warns.
                if (!obj1IsText && !obj2IsText) {
                    continue;
                }

                obj1.setCoords();
                obj2.setCoords();

                const isTextImagePair =
                    (obj1IsText && obj2.type === 'image') ||
                    (obj2IsText && obj1.type === 'image');

                const isTextTextPair = obj1IsText && obj2IsText;

                if (!isTextImagePair && !isTextTextPair) {
                    // Text overlapping some other non-photo, non-text
                    // object type isn't one of the two cases we warn
                    // about.
                    continue;
                }

                // KP FIX - use the real pixel-perfect check for BOTH
                // cases (text-vs-photo and text-vs-text), not just
                // text-vs-photo like before. Bounding-box intersection
                // alone flags a warning even when the visible pixels
                // never actually touch (e.g. diagonal/rotated text, or
                // text whose bounding box has a lot of empty padding
                // around the glyphs) - checking the real rendered
                // overlap removes those false positives so the warning
                // only shows when the text truly overlaps something.
                if (hasPixelOverlap(obj1, obj2, 10)) {

                    overlapMessage = isTextImagePair
                        ? '⚠ Your text overlaps the photo. Please move it away.'
                        : '⚠ Your text overlaps other text. Please move it away.';
                    break outerLoop;
                }
            }
        }

        if (overlapMessage) {

            setOverlapWarning(overlapMessage);

        } else {

            $('#overlap-warning').hide();
        }
    }
    // kk object overlap check 10-6-2026 - pixel perfact

    function removeObjectControls(obj) {
        if (obj.type == "i-text") {
            obj.setControlsVisibility({
                mtr: false,
                ml: false,
                mt: false,
                mr: false,
                mb: false,
                bl: false,
                br: false,
                tl: false,
                tr: false
            });
        } else {
            obj.setControlsVisibility({
                mtr: false,
                ml: false,
                mt: false,
                mr: false,
                mb: false,
                bl: false,
                br: false,
                tl: false,
                tr: false
            });
        }
    }

    // update height width based on input
    /* var previousSizeValue = $("#canvasheightandwidth").val();
    $("#canvasheightandwidth").on('change', function () {
        var currentValue = $(this).val();
        if (currentValue !== previousSizeValue && previousSizeValue !== "") {
            if (canvas.getObjects().length > 0) {
                // Show the confirmation modal
                $('#clearCanvasModal').modal('show');
            } else {
                changeCanvasSize(currentValue);
                previousSizeValue = currentValue;
            }
        } else {
            changeCanvasSize(currentValue);
            previousSizeValue = currentValue;
        }
    }); */

    // Event listener for confirming canvas clearing
    /* $('#clearCanvasConfirm').on('click', function () {
        // Clear the canvas
        canvas.clear();

        // Close the modal
        $('#clearCanvasModal').modal('hide');
    });

    // Event listener for canceling canvas clearing
    $('#cancelClearCanvas').on('click', function () {
        console.log(previousSizeValue);
        // Revert dropdown to its old value
        $('#canvasheightandwidth').val(previousSizeValue);
    }); */
    /* function changeCanvasSize(sizeData) {
        var cmData = 50;
        var cmDataPixel = 0;
        var canvasHeightWidthVal = sizeData;
        if (canvasHeightWidthVal) {
            if (canvasHeightWidthVal == 2) {
                cmData = 100;
            } else if (canvasHeightWidthVal == 4) {
                cmData = 200;
            }
            cmDataPixel = cmToPixel(cmData);
        } else {
            cmDataPixel = cmToPixel(cmData);
        }
        resetCanvasSize(canvas, { 'width': cmDataPixel, 'height': cmDataPixel });
        // canvas.setWidth(cmDataPixel).setHeight(cmDataPixel);
        // addRulers(cmDataPixel, cmDataPixel);

        if (canvasHeightWidthVal == 2) {
            // setTypeTowSize();
            // textSizeInput.value = 150;
            $('.for200').hide();
            $('.for100').show();
        } else if (canvasHeightWidthVal == 4) {
            // setTypeThreeSize();
            // textSizeInput.value = 350;
            $('.for100').hide();
            $('.for200').show();
        } else {
            // setDefaultSize();
            textSizeInput.value = 50;
        }
        resetUndoRedo();
        zoomTo(1);
    } */

    function renderIcon(icon) {
        return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
            var size = this.cornerSize;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(icon, -size / 2, -size / 2);
            ctx.restore();
        }
    }

    /*$("#bgImageUpload").on('change', function () {
       // console.log($(this));
        const inputElement = $(this)[0]; // Get the DOM element
        const files = inputElement.files; // Access files property using the DOM element

        if (files.length > 0) { // Check if files were selected
            const fileReader = new FileReader();
            fileReader.readAsDataURL(files[0]); // Read the first file

            fileReader.addEventListener("load", function () {
                set_canvas_bg(this.result);
                bgImage = this.result;
            });
        }
        $(this).val("");
    });*/

   /* $("#bg-image-upload-button").on('click', function () {
        $("#bgImageUpload").trigger('click');
    });*/

    const mypopup = document.getElementById("mypopup");
    const mypopupcloseBtn = document.querySelector(".mypopupclose");

    // mypopupClose the mypopup when the 'x' is clicked
    mypopupcloseBtn.onclick = function() {
        mypopup.style.display = "none";
    };

    // mypopupClose the mypopup when clicking outside the mypopup content
    window.onclick = function(event) {
        if (event.target === mypopup) {
            mypopup.style.display = "none";
        }
    };

    $("#single-image-upload-button").on('click', function () {
        /*image crop and upload in canvas*/
            $(this).addClass('cron-warned');
            sizeValidation(true);    
        /*image crop and upload in canvas*/

        /*if($(this).hasClass('cron-warned')) {
            sizeValidation(true);    
        } else {
            mypopup.style.display = "flex";
            $(this).addClass('cron-warned');
        }*/         
    });

    /*$("#uploadPhotoBtn").on('click', function () {
        sizeValidation(true);
        mypopup.style.display = "none";
    });*/

    function calculateRealSize(canvas, dpi = 96) {
        // Get the current dimensions of the canvas in pixels
        const canvasWidth = canvas.getWidth();
        const canvasHeight = canvas.getHeight();

        // KP FIX - measure against the base "fit-to-container" scale
        // (getBaseScale()), not the raw canvas.viewportTransform[0].
        // wall-view/sticker-view apply their own extra zoom on top of the
        // base fit scale (wall-view zooms out an additional ~0.35x for
        // display purposes only), so using the raw viewport scale here
        // made the canvas's real/print size look much bigger than
        // 100x100cm whenever wall-view was active. That incorrectly
        // failed sizeValidation() and popped the "wrong size" alert when
        // uploading from an empty canvas in wall-view. The canvas's real
        // logical size never actually changes when toggling views, so we
        // always measure it against the base fit scale instead.
        const scale = getBaseScale();

        // Calculate the real size in pixels
        const realWidthInPixels = canvasWidth / scale;
        const realHeightInPixels = canvasHeight / scale;

        // Convert pixels to inches (1 inch = dpi pixels)
        const realWidthInInches = realWidthInPixels / dpi;
        const realHeightInInches = realHeightInPixels / dpi;

        // Convert inches to centimeters (1 inch = 2.54 cm)
        const realWidthInCm = realWidthInInches * 2.54;
        const realHeightInCm = realHeightInInches * 2.54;
        return {
            width: realWidthInCm.toFixed(0),
            height: realHeightInCm.toFixed(0)
        };
    }


    function sizeValidation(imgUpload = false) {
        var retData = true;
        var alertContent = "";
        var currentSize = 2;
        var canvasImagesCount = canvas.getObjects('image').length;
        var maxImagesAllowed = { 1: 0, 2: 0, 4: 3 };
        var requiredCanvasSizes = {
            1: { width: 50, height: 50 },
            2: { width: 100, height: 100 },
            4: { width: 200, height: 200 }
        };

        var realSizeData = calculateRealSize(canvas);
        var canvasWidthInCm = realSizeData.width;//pixelsToCentimeters(canvas.width);
        var canvasHeightInCm = realSizeData.height;//pixelsToCentimeters(canvas.height);
        if (requiredCanvasSizes[currentSize]) {
            var requiredWidth = requiredCanvasSizes[currentSize].width;
            var requiredHeight = requiredCanvasSizes[currentSize].height;
           
            if (canvasWidthInCm == requiredWidth && canvasHeightInCm == requiredHeight &&
                canvasImagesCount <= maxImagesAllowed[currentSize]) {
               
                if (imgUpload) {
                    $("#singleImageUpload").trigger('click');
                } else {
                    return retData;
                }
            } else {
                if (canvasWidthInCm != requiredWidth || canvasHeightInCm != requiredHeight) {
                    alertContent = `${alertmsg3half} ${requiredWidth}x${requiredHeight} ${alertmsg3half2}`;
                    $('.size-alert-modal .modal-body').text(alertContent);
                    $('#sizeAlertModal').modal('show');
                    retData = false;
                    return retData;
                } else {
                    alertContent = `${alertmsg4_1}`;
                    $('.size-alert-modal .modal-body').text(alertContent);
                    $('#sizeAlertModal').modal('show');
                    retData = false;
                    return retData;
                }
            }
        } else {
            alertContent = alertmsg1;
            $('.size-alert-modal .modal-body').text(alertContent);
            $('#sizeAlertModal').modal('show');
            retData = false;
            return retData;
        }
    }

        /*image crop and upload in canvas*/
    let cropper = null;
    let uploadedFile = null;

    $ = jQuery;

    // KP FIX - restrict #singleImageUpload to image files only.
    // The accept attribute is just a hint for the OS file picker (some
    // browsers/OSes still let a user pick "All Files" and choose
    // anything), so we also hard-validate the actual file's MIME type
    // on change before it's ever read or sent anywhere.
    $('#singleImageUpload').attr('accept', 'image/*');

    function isValidImageFile(file) {
        return !!(file && file.type && file.type.indexOf('image/') === 0);
    }

    function rejectNonImageFile($input) {
        $input.val("");
        $('.size-alert-modal .modal-body').text('Please upload a valid image file (JPG, PNG, GIF, etc.).');
        $('#sizeAlertModal').modal('show');
    }

    // Upload Image
    $("#singleImageUpload").on("change", function (event) {

        // Reset previous data
        uploadedFile = null;

        if (cropper) {
            cropper.destroy();
            cropper = null;
        }

        uploadedFile = this.files[0];

        if (!uploadedFile) {
            return;
        }

        if (!isValidImageFile(uploadedFile)) {
            uploadedFile = null;
            rejectNonImageFile($(this));
            // Stop the second change handler below from also running
            // (and trying to upload the same invalid file).
            event.stopImmediatePropagation();
            return;
        }

        const reader = new FileReader();

        reader.onload = function (e) {

            $("#cropImage").attr("src", e.target.result);

            $("#cropModal").modal("show");

        };

            reader.readAsDataURL(uploadedFile);

            $(this).val("");
    });

   // Initialize Cropper
    $('#cropModal').on('shown.bs.modal', function () {

        if (cropper) {
            cropper.destroy();
        }

        cropper = new Cropper(
            document.getElementById('cropImage'),
            {
                viewMode: 1,
                autoCropArea: 1,
                modal: true,          // Dark overlay outside crop box
                guides: true,
                center: true,
                highlight: true,
                background: false,

                responsive: true,
                movable: true,
                zoomable: true,
                scalable: true,
                rotatable: false,

                dragMode: 'move',

               /* ready: function () {

                    const containerData = cropper.getContainerData();

                    cropper.setCropBoxData({
                        left: containerData.width * 0.1,
                        top: containerData.height * 0.05,
                        width: containerData.width * 0.8,
                        height: containerData.height * 0.9
                    });
                }*/
            }
        );
    });


    $('#cropImageBtn').on('click', function () {

    if (!cropper) {
        return;
    }

    $('#cropModal').modal('hide');

    $('.bg-loader .bg-loader-btn span')
        .text("Removing your background, please wait...");

    $('.bg-loader').show();

    // Always use current crop selection
        cropper.getCroppedCanvas({
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high'
        }).toBlob(function (blob) {

            const formData = new FormData();

            formData.append(
                'image',
                blob,
                'cropped-image.png'
            );

            $.ajax({

                url: 'https://inspirewallsticker.photos/removebgapi.php',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,

                success: function (response) {

                    if (response.error) {

                        $('.size-alert-modal .modal-body').text(response.error);
                        $('#sizeAlertModal').modal('show');

                    } else {

                        $(".bg-editor-canvas").removeClass("page-started-wall-view no-upload-image");
                        /*Temporary image add class  in sticker*/
                         $(".bg-editor-canvas").removeClass("sticker-no-image-upload");
                        /*Temporary image add class  in sticker*/
                        $(".canvas-editor-note, .canvas-sticker-note").addClass("hidden");

                        var base64Data = `data:${response.mime_type};base64,${response.image}`;

                        canvas_add_image(base64Data);
                        $('#bg_canvas_texttransform').attr('placeholder', '');

                        // enable/disable size slider 
                        $('#imagescale').prop('disabled', false);
                    }

                    $('.bg-loader').hide();
                    $('.bg-loader .bg-loader-btn span').text("Processing...");

                    // Cleanup
                    if (cropper) {
                        cropper.destroy();
                        cropper = null;
                    }

                    uploadedFile = null;
                },

                error: function (jqXHR, textStatus) {

                    $('.size-alert-modal .modal-body').text('Server error: ' + textStatus);

                    $('#sizeAlertModal').modal('show');

                    $('.bg-loader').hide();
                    $('.bg-loader .bg-loader-btn span').text("Processing...");
                }

            });

        }, 'image/png');

    });
    // Cleanup if modal closed manually
    $('#cropModal').on('hidden.bs.modal', function () {

        if (cropper) {
            cropper.destroy();
            cropper = null;
        }

        $("#cropImage").attr('src', '');
    });

    $('#resetCrop').on('click', function(e){

        e.preventDefault();

        if (!cropper) {
            return;
        }

        cropper.reset();

        // Optional: ensure full image is selected
        cropper.setData({
            x: 0,
            y: 0
        });

    });

    $('#changePhoto').on('click', function(e){

        e.preventDefault();

        $('#cropModal').modal('hide');

        // Clear old data
        if (cropper) {
            cropper.destroy();
            cropper = null;
        }

        uploadedFile = null;

        // Open file picker
        $('#singleImageUpload').trigger('click');

    });

    /*image crop and upload in canvas*/


    $("#singleImageUpload").on('change', function () {
        const inputElement = $(this)[0]; // Get the DOM element
        var file = inputElement.files[0];
        if (file) { // Check if files were selected
            if (!isValidImageFile(file)) {
                // Already caught and alerted by the first change handler
                // above (which also stops this handler from running via
                // stopImmediatePropagation) - this is just a defensive
                // fallback so an invalid file is never uploaded from here.
                return;
            }
            $('.bg-loader .bg-loader-btn span').text("Removing your background, please wait...");
            $('.bg-loader').show();
            var formData = new FormData();
            formData.append('image', file);
            $.ajax({
                url: 'https://inspirewallsticker.photos/removebgapi.php',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.error) {
                        var bgError = response.error;
                        $('.size-alert-modal .modal-body').text(bgError);
                        $('#sizeAlertModal').modal('show');
                    } else {
                        // Check active toggle
                        var activeView = $(".togglebtn.active").data("view");
                        
                        if (activeView === "wall") {
                            $(".bg-editor-canvas").removeClass("page-started-wall-view no-upload-image");
                        } else {
                            $(".bg-editor-canvas").removeClass("wall-view");
                           // $(".bg-editor-canvas").addClass("sticker-view");
                        }
                        /*Temporary image add class  in sticker*/
                         $(".bg-editor-canvas").removeClass("sticker-no-image-upload");
                        /*Temporary image add class  in sticker*/

                       // jQuery(".bg-editor-canvas").removeClass("page-started-wall-view no-upload-image");
                         jQuery(".canvas-editor-note , .canvas-sticker-note").addClass("hidden");
                        var base64Data = `data:${response.mime_type};base64,${response.image}`;
                        canvas_add_image(base64Data);
                    }
                    $('.bg-loader').hide();
                    $('.bg-loader .bg-loader-btn span').text("Processing...");
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var bgError = 'Server error: ' + textStatus;
                    $('.size-alert-modal .modal-body').text(bgError);
                    $('#sizeAlertModal').modal('show');
                    $('.bg-loader').hide();
                    $('.bg-loader .bg-loader-btn span').text("Processing...");
                }
            }); 
        }
        $(this).val("");
    });

    $(document).on('click', '.canvas_remove_image', function (e) {
        e.preventDefault();
        var index = $(this).parent().index();
        //$('#recentUploadConfirm').attr('data-index', index);
       // $('#recentUploadModal').modal('show');
    });

    /*$(document).on('click', '#recentUploadConfirm', function (e) {
        var curIndex = $(this).attr('data-index');
        $('.recent-upload').children().eq(curIndex).remove();
        $('#recentUploadModal').modal('hide');
        $(this).attr('data-index', '');
        if (jQuery('.imglist-item').length > 3) {
            $('.recent-upload-prev').show();
            $('.recent-upload-next').show();
            $(".recent-upload").css('left', "10px");
        } else {
            $('.recent-upload-prev').hide();
            $('.recent-upload-next').hide();
            $(".recent-upload").css('left', "0px");
        }
        if (jQuery('.imglist-item').length <= 0) {
            $('.recent-upload-container').hide();
        }
    });*/

    /*$(document).on('click', '.canvas_add_replace_image', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        if (canvas.getActiveObject() && 'image' == canvas.getActiveObject().type) {
            var j = new Image();
            j.src = url;
            j.onload = function () {
                console.log(canvas.getActiveObject().width);
                var p = new fabric.Image(j);
                var m = j.width;
                var l = canvas.getActiveObject().width;
                var n = 1;
                var w = canvas.getActiveObject().width;
                var h = canvas.getActiveObject().height;
                if (j.width > w || j.height > h) {
                    j.width > j.height ? m = j.width : m = j.height;
                    w > h ? l = w : l = h;
                    n = l / m;
                }
                p.scale(n);
                p.orig_src = j.src;
                p.left = canvas.getActiveObject().left;
                p.top = canvas.getActiveObject().top;
                p.angle = canvas.getActiveObject().angle;
                p.opacity = canvas.getActiveObject().opacity;
                //p.crossOrigin="Anonymous"
                canvas.insertAt(p, canvas.getObjects().indexOf(canvas.getActiveObject()));
                canvas.remove(canvas.getActiveObject());
                canvas.setActiveObject(p);
                canvas.renderAll();
            }
            return;
        }
        var sizeValidationData = sizeValidation();
        if (sizeValidationData) {
            canvas_add_image(url, 0, 0, false);
        }
    });*/

    $(document).on('click', '.sample-bg-image', function (e) {
        var imgSrc = $(this).find('img').attr('src');
        set_canvas_bg(imgSrc);
    });

    // set_canvas_bg(a)
    let bgData = "";

    function set_canvas_bg(a) {
        fabric.Image.fromURL(a, function (b) {
            b.set({
                originX: "left",
                originY: "top"
            });
            var c = parseInt(canvas.width) / parseInt(b.getScaledWidth());
            b.scale(c);
            if (canvas.getHeight() > b.getScaledHeight()) {
                b.scaleToHeight(canvas.getHeight())
            }
            b.left = (canvas.getWidth() - b.getScaledWidth()) / 2;
            b.top = (canvas.getHeight() - b.getScaledHeight()) / 2;
            canvas.setBackgroundImage(b, canvas.renderAll.bind(canvas));
            bgData = b;
        })
    }

    function canvas_add_image(b, a = 0, g = 0, recentUpload = true) {
    var j = new Image();
    j.src = b;

    // KP FIX - clear the text box and its Text height/width fields
    // whenever a photo is uploaded, so any demo/leftover text values
    // never carry into a real order alongside the newly uploaded photo.
    $('#bg_canvas_texttransform').val("");
    lastValidTransformText = "";
    $('#textheight, #textwidth').val("0");
    //enable/disable size slider
    $('#textSizeInput').prop('disabled', true);
    // KP FIX - reset the Colour swatch to black explicitly on photo
    // upload too, matching resetTextData()'s existing reset behaviour.
    //textColorInput.value = "#000000";
    //$('.bgColorPicker-container .clr-field').css('color', "#000000");

    // KP FEATURE - if there's no text on the canvas yet, zero out the
    // Text Size slider (#textSizeInput) to clearly show there's no text
    // yet, mirroring the Image Size slider getting zeroed out in
    // addText() whenever text is added before any image exists. This
    // must NOT affect the fontSize the customer's first typed line
    // actually gets - addText() explicitly falls back to the default
    // textFontSize for the very first text block regardless of what
    // this slider currently shows.
    var hasExistingText = canvas.getObjects().some(function (obj) {
        return obj.type === 'i-text';
    });
   // if (!hasExistingText) {
        textSizeInput.min = 0;
        textSizeInput.value = 0;
        textSizeInput.style.background = `linear-gradient(to right, rgb(8, 195, 128) 0%, #3b3b3b 0%)`;
    //}

    j.onload = function () {
        var p = new fabric.Image(j);

        // KP UPDATE - client feedback: initial upload was rendering too
        // small. The old logic below kept the image at its real/native
        // pixel size (only scaling DOWN if bigger than the 100cm canvas),
        // so a small source image (e.g. a phone screenshot) would land on
        // the canvas at a tiny true-to-life size. Now every upload is
        // normalized on add: the longer side (whichever of width/height
        // is bigger) is always scaled to exactly defaultLongSideCm,
        // scaling UP small images and DOWN large ones, so uploads are
        // consistently sized regardless of the source image's native
        // resolution.
        var defaultLongSideCm = 70;
        var realWidthCm = (j.width / 96) * 2.54;
        var realHeightCm = (j.height / 96) * 2.54;

        if (realWidthCm >= realHeightCm) {
            p.scaleToWidth(cmToPixel(defaultLongSideCm));
        } else {
            p.scaleToHeight(cmToPixel(defaultLongSideCm));
        }

        //p.top = cmToPixel(12);
        // KP FIX - center against the fixed logical canvas_width/
        // canvas_height (always the true 100cm canvas size) instead of
        // re-deriving it from canvas.getWidth()/getHeight() divided by
        // the *currently active* viewportTransform zoom. That division
        // only produced the correct logical size when the canvas
        // happened to already be at the plain fit-to-container scale.
        // On a second (or later) upload while wall-view was active, the
        // canvas was still sitting at wall-view's extra ~0.35x
        // zoomed-out transform from the previous upload, so dividing by
        // it hugely inflated the computed width/height and the new image
        // got centered against that wrong, inflated size - pushing it
        // off-center. Sticker-view never showed this bug because its
        // zoom always equals the base fit scale exactly, so the old
        // division always happened to cancel out correctly.
        p.top = cmToPixel(0.3); // cmToPixel(2); // KP FIX - photo default moved closer to the top of the canvas (was 10% of canvas height, which pushed it noticeably down)
        p.orig_src = j.src;
        p.uniqId = uniqId++;
        p.crossOrigin = 'anonymous';

        // Center image horizontally
        const canvasWidth = canvas_width;

        p.set({
            left: (canvasWidth - p.getScaledWidth()) / 2,
            lockScalingFlip: true,
            flipX: false,
            flipY: false
        });


        canvas.add(p);
        canvas.setActiveObject(p);
        updateInputs(p);
        canvas.renderAll();

        // KP FIX - respect whichever view the user currently has active
        // instead of always forcing wall-view here. Previously this line
        // unconditionally triggered #wall-view-btn on every image upload,
        // so even after a user explicitly clicked sticker-view and then
        // uploaded, the canvas would jump back to the zoomed-out
        // wall-view. Now we re-trigger whichever toggle button is
        // currently marked active, so:
        //  - default page load (wall-view active) -> first upload still
        //    lands in wall-view, same as before.
        //  - user clicks sticker-view, then uploads -> stays in
        //    sticker-view, rendered at its normal/original scale.
        var currentViewBtn = jQuery('.canvas-view-toggle-wrap .togglebtn.active');
        if (currentViewBtn.length && currentViewBtn.attr('id') === 'sticker-view-btn') {
            jQuery('#sticker-view-btn').trigger('click');
        } else {
            jQuery('#wall-view-btn').trigger('click');
        }

        // Handle recent uploads
            if (recentUpload) {
                $('.recent-upload-container').show();
                $('.recent-upload').prepend('<div class="imglist-item"><div class="canvas_add_replace_image" data-url="' + j.src + '"><img src="' + j.src + '"></div><span class="canvas_remove_image"></span></div>');
                if (jQuery('.imglist-item').length > 3) {
                    $('.recent-upload-prev').show();
                    $('.recent-upload-next').show();
                    $(".recent-upload").css('left', "10px");
                } else {
                    $('.recent-upload-prev').hide();
                    $('.recent-upload-next').hide();
                    $(".recent-upload").css('left', "0px");
                }
            }
    };
}

    // Initial canvas dimensions
    var screenWidth = $(window).width();
    var sizeCanvas = canvas.getWidth() / canvas.viewportTransform[0];
    if (screenWidth < 768) {
        var cornerSize = 300;
        var controlSize = 300;
        var textFontSize = 350;
        var dimentionSize = 150;
        var widthTextTop = 120;
        resizeCanvas(canvas, sizeCanvas);
    } else if (screenWidth < 1024) {
        var cornerSize = 150;
        var controlSize = 150;
        var crop_img_corners_size = 14;
        var textFontSize = 250;
        var dimentionSize = 100;
        var widthTextTop = 80;
        resizeCanvas(canvas, sizeCanvas);
    } else if (screenWidth < 1200) {
        var cornerSize = 150;
        var controlSize = 150;
        var crop_img_corners_size = 14;
        var textFontSize = 250;
        var dimentionSize = 100;
        var widthTextTop = 80;
        resizeCanvas(canvas, sizeCanvas);
    } else {
        var cornerSize = 50;
        var controlSize = 70;
        var crop_img_corners_size = 16;
        var textFontSize = 150;
        var dimentionSize = 50;
        var widthTextTop = 40;
        resizeCanvas(canvas, sizeCanvas);
    }
    var textFontSize = 165;
    textSizeInput.value = textFontSize;
    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.borderColor = "black";
    fabric.Object.prototype.cornerColor = "black";
    fabric.Object.prototype.cornerSize = 30;
    // fabric.Object.prototype.transparentCorners = true;

    function resizeCanvas(canvas, sizeBeforeResize) {
        const containerSize = {
            width: document.querySelector('.bg-canvas-holder').offsetWidth,
            height: document.querySelector('.bg-canvas-holder').offsetWidth,
        }
        if (containerSize.width === 0) {
            containerSize.width = containerSize.height = sizeBeforeResize;
        }

        const newScale = containerSize.width / sizeBeforeResize;
        // if(newScale === 0) {
        //     newScale = 1;
        // }
        const oldScale = canvas.viewportTransform[0];

        canvas.setDimensions(containerSize);
        // canvas.setZoom(newScale * oldScale);

        canvas.setViewportTransform([newScale * oldScale, 0, 0, newScale * oldScale, 0, 0]);
        canvas.renderAll();

        //canvas.zoomToPoint(new fabric.Point(canvas.width / 2, canvas.height / 2), newScale * oldScale)
        //canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0]);
    }

    function resetCanvasSize(canvas, originalSize) {
        // Apply the new dimensions to the canvas
        canvas.setDimensions({ width: originalSize.width, height: originalSize.height });

        // Set the new viewport transform, maintaining the scaling factor
        canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);

        // Re-render the canvas
        canvas.renderAll();
        resizeCanvas(canvas, canvas.getWidth() / canvas.viewportTransform[0]);
    }


   /* function setDefaultSize() {
        canvas.setBackgroundImage(null);
        canvas.setBackgroundColor('');
        fabric.Object.prototype.cornerSize = 25;
        addCustomRotationControl(35);
        addCustomDeleteControl(35);
        addCustomResizeControl(35);
        addWidthDimentionControls();
        addHeightDimentionControls();
        canvas.renderAll();
    }*/

    /*function setTypeTowSize() {
        canvas.setBackgroundImage(null);
        canvas.setBackgroundColor('');
        fabric.Object.prototype.cornerSize = cornerSize;
        addCustomRotationControl(controlSize);
        addCustomDeleteControl(controlSize);
        addCustomResizeControl(controlSize);
        addWidthDimentionControls(8, 20, 20, 40, dimentionSize, widthTextTop);
        addHeightDimentionControls(8, 20, 20, -40, dimentionSize);
        canvas.renderAll();
    }*/

    /*function setTypeThreeSize() {
        canvas.setBackgroundImage(null);
        canvas.setBackgroundColor('');
        var newControlSize = controlSize * 2;
        var newCornerSize = cornerSize * 2;
        var newDimentionSize = dimentionSize * 2;
        var newWidthTextTop = widthTextTop * 2;
        fabric.Object.prototype.cornerSize = newCornerSize;
        addCustomRotationControl(newControlSize);
        addCustomDeleteControl(newControlSize);
        addCustomResizeControl(newControlSize)
        addWidthDimentionControls(18, 50, 40, 70, newDimentionSize, newWidthTextTop);
        addHeightDimentionControls(18, 50, 40, -70, newDimentionSize);
        textSizeInput.value = textFontSize * 2;
        canvas.renderAll();
    }*/

    // For Horizontal 
    function addWidthDimentionControls(lineWidth = 1, widthLineTop = 0, widthLineStartEndSize = 6, widthLineStartEndOffsetY = 20, widthTextFontSize = 16, widthTextTop = 0, widthTextGap = 15) {
        // const getCanvasScale = (fabricObject) => {
        //     const canvas = fabricObject.canvas;
        //     return canvas.viewportTransform[0];
        // };

        // fabric.Object.prototype.controls.widthLineStartControl = new fabric.Control({
        //     x: 0,
        //     y: 0.5,
        //     offsetX: 0,
        //     offsetY: widthLineStartEndOffsetY, // Adjust the offset to position the line below the object
        //     cursorStyle: 'default',
        //     // KP FIX - scale the fixed offsetY by getViewScaleRatio() so
        //     // the tick stays proportionally close to the object in wall
        //     // view instead of a fixed distance away (see
        //     // scaledOffsetPositionHandler()).
        //     positionHandler: scaledOffsetPositionHandler(0, widthLineStartEndOffsetY),
        //     render: function (ctx, left, top, styleOverride, fabricObject) {
        //         ctx.save();

        //         const scale = getCanvasScale(fabricObject);
        //         const ratio = getViewScaleRatio(); // KP FIX

        //         // Apply the object's transformation to the control
        //         ctx.translate(left, top);
        //         ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        //         ctx.translate(-left, -top);

        //         var scaledWidth = fabricObject.getScaledWidth();

        //         // Render the start of the width line
        //         ctx.strokeStyle = 'black';
        //         ctx.lineWidth = lineWidth * ratio; // KP FIX
        //         var tickSize = widthLineStartEndSize * ratio; // KP FIX
        //         ctx.beginPath();  // KP -  display dimention in cm of the image width
        //         ctx.moveTo(left - (scaledWidth * scale) / 2, top - tickSize);
        //         ctx.lineTo(left - (scaledWidth * scale) / 2, top + tickSize);
        //         ctx.stroke();

        //         ctx.restore();
        //     }
        // });
        // fabric.Object.prototype.controls.widthLineEndControl = new fabric.Control({
        //     x: 1, // Position at the right edge of the object
        //     y: 0.5,
        //     offsetX: 0,
        //     offsetY: widthLineStartEndOffsetY, // Adjust the offset to position the line below the object
        //     cursorStyle: 'default',
        //     positionHandler: scaledOffsetPositionHandler(0, widthLineStartEndOffsetY), // KP FIX
        //     render: function (ctx, left, top, styleOverride, fabricObject) {
        //         ctx.save();

        //         const scale = getCanvasScale(fabricObject);
        //         const ratio = getViewScaleRatio(); // KP FIX

        //         // Apply the object's transformation to the control
        //         ctx.translate(left, top);
        //         ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        //         ctx.translate(-left, -top);

        //         var scaledWidth = fabricObject.getScaledWidth();

        //         // Render the end of the width line
        //         ctx.strokeStyle = 'black';
        //         ctx.lineWidth = lineWidth * ratio; // KP FIX
        //         var tickSize = widthLineStartEndSize * ratio; // KP FIX
        //         ctx.beginPath();  // KP -  display dimention in cm of the image width
        //         ctx.moveTo(left - (scaledWidth * scale) / 2, top - tickSize);
        //         ctx.lineTo(left - (scaledWidth * scale) / 2, top + tickSize);
        //         ctx.stroke();

        //         ctx.restore();
        //     }
        // });

        // fabric.Object.prototype.controls.widthLineControl = new fabric.Control({
        //     x: 0,
        //     y: 0.5,
        //     offsetX: 0,
        //     offsetY: 25, // Adjust the offset to position the line below the object
        //     cursorStyle: 'default',
        //     positionHandler: scaledOffsetPositionHandler(0, 25), // KP FIX
        //     render: function (ctx, left, top, styleOverride, fabricObject) {
        //         ctx.save();

        //         ctx.translate(left, top);
        //         ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        //         ctx.translate(-left, -top);

        //         const scale = getCanvasScale(fabricObject);
        //         const ratio = getViewScaleRatio(); // KP FIX

        //         // Calculate scaled dimensions
        //         var scaledWidth = fabricObject.getScaledWidth();
        //         var scaledHeight = fabricObject.getScaledHeight();

        //         // Calculate the position of the line
        //         var lineY = top - (5 * ratio) + (widthLineTop * ratio); // KP FIX

        //         // Render the width line
        //         ctx.strokeStyle = 'black';
        //         ctx.lineWidth = lineWidth * ratio; // KP FIX
        //         ctx.beginPath(); // KP -  display dimention in cm of the image width
        //         ctx.moveTo(left - (scaledWidth * scale) / 2, lineY);
        //         ctx.lineTo(left + (scaledWidth * scale) / 2, lineY);
        //         ctx.stroke();

        //         ctx.restore();
        //     }
        // });
        // /*KP - Mobile screen masurement text display in position */
        //  const isMobileforwidth = window.innerWidth <= 767;
        //  /*KP - Mobile screen masurement text display in position */

        // // KP UPDATE - widthControl now sits BELOW the widthLineControl/
        // // widthLineStartControl/widthLineEndControl (offsetY = the line's
        // // own offset + widthTextGap), instead of sharing the exact same
        // // offsetY as the line (which used to make the label sit directly
        // // on top of the line, requiring a white box underneath just to
        // // hide it). No box/border anymore - just the plain "Xcm" label.
        // fabric.Object.prototype.controls.widthControl = new fabric.Control({
        //     x: 0,
        //     y: 0.5,
        //     offsetX: 0,
        //     offsetY: widthLineStartEndOffsetY + widthTextGap, // below widthLineControl / widthLineStartControl / widthLineEndControl
        //     cursorStyle: 'default',
        //     positionHandler: scaledOffsetPositionHandler(0, widthLineStartEndOffsetY + widthTextGap), // KP FIX
        //     render: function (ctx, left, top, styleOverride, fabricObject) {
        //         ctx.save();

        //         ctx.translate(left, top);
        //         ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        //         ctx.translate(-left, -top);

        //         const ratio = getViewScaleRatio(); // KP FIX

        //         var measureTextadditionval = isMobileforwidth ? 12 : 20;
        //         var widthTextFontSizeNew = (isMobileforwidth ? 12 : widthTextFontSize) * ratio; // KP FIX

        //         ctx.font = '600 ' + widthTextFontSizeNew + 'px Montserrat BBM';
        //         ctx.textAlign = 'center';
        //         ctx.textBaseline = 'middle';

        //         var scaledWidth = fabricObject.width * fabricObject.scaleX;
        //         var widthText = pixelsToCentimeters(scaledWidth) + 'cm';

        //         // === plain text, no background box/border ===
        //         ctx.fillStyle = 'black';
        //         ctx.fillText(widthText, left, top);
        //         ctx.restore();
        //     }
        // });
    }

    // For Vertical 
    function addHeightDimentionControls(lineWidth = 1, heightLineLeft = 0, heightLineStartEndSize = 6, heightLineStartEndOffsetX = -20, heightTextFontSize = 16, heightTextGap = 28) {
        // const getCanvasScale = (fabricObject) => {
        //     const canvas = fabricObject.canvas;
        //     return canvas.viewportTransform[0];
        // };

        // // Define a custom control for displaying the height line
        // fabric.Object.prototype.controls.heightLineStartControl = new fabric.Control({
        //     x: -0.5, // Position on the left side of the object
        //     y: -0.5,
        //     offsetX: heightLineStartEndOffsetX, // Adjust the offset to position the line correctly
        //     offsetY: 0,
        //     cursorStyle: 'default',
        //     positionHandler: scaledOffsetPositionHandler(heightLineStartEndOffsetX, 0), // KP FIX
        //     render: function (ctx, left, top, styleOverride, fabricObject) {
        //         ctx.save();

        //         // Apply the object's transformation to the control
        //         ctx.translate(left, top);
        //         ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        //         ctx.translate(-left, -top);

        //         const ratio = getViewScaleRatio(); // KP FIX

        //         // Calculate the position of the height line start
        //         var leftPosition = left - (1 * ratio); // KP FIX

        //         // Render the height line start
        //         ctx.strokeStyle = 'black';
        //         ctx.lineWidth = lineWidth * ratio; // KP FIX
        //         var tickSize = heightLineStartEndSize * ratio; // KP FIX
        //         ctx.beginPath(); // KP - display dimention in cm of the image height
        //         ctx.moveTo(leftPosition - tickSize, top);
        //         ctx.lineTo(leftPosition + tickSize, top);
        //         ctx.stroke();

        //         ctx.restore();
        //     }
        // });

        // fabric.Object.prototype.controls.heightLineEndControl = new fabric.Control({
        //     x: -0.5, // Position on the left side of the object
        //     y: 0.5,
        //     offsetX: heightLineStartEndOffsetX, // Adjust the offset to position the line correctly
        //     offsetY: 0,
        //     cursorStyle: 'default',
        //     positionHandler: scaledOffsetPositionHandler(heightLineStartEndOffsetX, 0), // KP FIX
        //     render: function (ctx, left, top, styleOverride, fabricObject) {
        //         ctx.save();

        //         // Apply the object's transformation to the control
        //         ctx.translate(left, top);
        //         ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        //         ctx.translate(-left, -top);

        //         const ratio = getViewScaleRatio(); // KP FIX

        //         // Calculate the position of the height line end
        //         var leftPosition = left - (1 * ratio); // KP FIX

        //         // Render the height line end
        //         ctx.strokeStyle = 'black';
        //         ctx.lineWidth = lineWidth * ratio; // KP FIX
        //         var tickSize = heightLineStartEndSize * ratio; // KP FIX
        //         ctx.beginPath(); // KP - display dimention in cm of the image height
        //         ctx.moveTo(leftPosition - tickSize, top);
        //         ctx.lineTo(leftPosition + tickSize, top);
        //         ctx.stroke();

        //         ctx.restore();
        //     }
        // });

        // fabric.Object.prototype.controls.heightLineControl = new fabric.Control({
        //     x: -0.5, // Position on the left side of the object
        //     y: 0,
        //     offsetX: -20, // -20, // Adjust the offset to position the line correctly
        //     offsetY: 0,
        //     cursorStyle: 'default',
        //     positionHandler: scaledOffsetPositionHandler(-20, 0), // KP FIX
        //     render: function (ctx, left, top, styleOverride, fabricObject) {
        //         ctx.save();

        //         // Apply the object's transformation to the control
        //         ctx.translate(left, top);
        //         ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        //         ctx.translate(-left, -top);

        //         const scale = getCanvasScale(fabricObject);
        //         const ratio = getViewScaleRatio(); // KP FIX

        //         // Calculate the position of the height line
        //         var scaledHeight = fabricObject.height * fabricObject.scaleY;
        //         var leftPosition = left - (1 * ratio) - (heightLineLeft * ratio); // KP FIX

        //         // Render the height line
        //         ctx.strokeStyle = 'black';
        //         ctx.lineWidth = lineWidth * ratio; // KP FIX
        //         ctx.beginPath(); // KP - display dimention in cm of the image height
        //         ctx.moveTo(leftPosition, top - (scaledHeight * scale) / 2);
        //         ctx.lineTo(leftPosition, top + (scaledHeight * scale) / 2);
        //         ctx.stroke();

        //         ctx.restore();
        //     }
        // });
        // /*KP - Mobile screen masurement text display in position */
        // const isMobileforheight = window.innerWidth <= 767;
        // /*KP - Mobile screen masurement text display in position */
        // // KP UPDATE - heightControl now sits further out (beyond/to the
        // // left of) heightLineControl/heightLineStartControl/
        // // heightLineEndControl - offsetX is the line's own offset MINUS
        // // heightTextGap (more negative = further left) - instead of
        // // sharing the exact same offsetX as the line, which used to make
        // // the label sit directly on top of the line and needed a white
        // // box underneath just to hide it. No box/border anymore - just
        // // the plain "Xcm" label.
        // fabric.Object.prototype.controls.heightControl = new fabric.Control({
        //     x: -0.5,
        //     y: 0,
        //     offsetX: heightLineStartEndOffsetX - heightTextGap, // beyond heightLineControl / heightLineStartControl / heightLineEndControl
        //     offsetY: 0,
        //     cursorStyle: 'default',
        //     positionHandler: scaledOffsetPositionHandler(heightLineStartEndOffsetX - heightTextGap, 0), // KP FIX
        //     render: function (ctx, left, top, styleOverride, fabricObject) {
        //         ctx.save();

        //         ctx.translate(left, top);
        //         ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
        //         ctx.translate(-left, -top);

        //         const ratio = getViewScaleRatio(); // KP FIX

        //         var heightTextFontSizeNew = (isMobileforheight ? 12 : heightTextFontSize) * ratio; // KP FIX
        //         ctx.font = '600 ' + heightTextFontSizeNew + 'px Montserrat BBM';
        //         ctx.textAlign = 'center';
        //         ctx.textBaseline = 'middle';

        //         var scaledHeight = fabricObject.height * fabricObject.scaleY;
        //         var heightText = pixelsToCentimeters(scaledHeight) + 'cm';

        //         // === plain text, no background box/border ===
        //         ctx.fillStyle = 'black';
        //         ctx.fillText(heightText, left, top);
        //         ctx.restore();
        //     }
        // });
    }

    // KP FIX - draws a small dark rounded-rect label with white text,
    // used as an "alt text" style tooltip above the delete/resize/move
    // icons while they're hovered (see hoveredControlKey). (x, y) is the
    // bottom-center point of the label (i.e. where it sits just above
    // the icon). Drawn in plain, un-rotated canvas space so the label
    // always reads upright even if the underlying object is rotated.
    function drawControlTooltip(ctx, x, y, text) {
        ctx.save();
        ctx.font = '13px Arial, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        var paddingX = 8;
        var boxHeight = 22;
        var textWidth = ctx.measureText(text).width;
        var boxWidth = textWidth + paddingX * 2;
        var boxX = x - boxWidth / 2;
        var boxY = y - boxHeight;
        var radius = 4;

        ctx.beginPath();
        ctx.moveTo(boxX + radius, boxY);
        ctx.lineTo(boxX + boxWidth - radius, boxY);
        ctx.quadraticCurveTo(boxX + boxWidth, boxY, boxX + boxWidth, boxY + radius);
        ctx.lineTo(boxX + boxWidth, boxY + boxHeight - radius);
        ctx.quadraticCurveTo(boxX + boxWidth, boxY + boxHeight, boxX + boxWidth - radius, boxY + boxHeight);
        ctx.lineTo(boxX + radius, boxY + boxHeight);
        ctx.quadraticCurveTo(boxX, boxY + boxHeight, boxX, boxY + boxHeight - radius);
        ctx.lineTo(boxX, boxY + radius);
        ctx.quadraticCurveTo(boxX, boxY, boxX + radius, boxY);
        ctx.closePath();
        ctx.fillStyle = 'rgba(44, 72, 93, 0.95)';
        ctx.fill();

        ctx.fillStyle = '#ffffff';
        ctx.fillText(text, boxX + boxWidth / 2, boxY + boxHeight / 2 + 1);
        ctx.restore();
    }

    function renderIcon(icon) {
        return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
            // KP FIX - scale the icon by getViewScaleRatio() so it's the
            // same proportional size relative to the object in every
            // view (see getViewScaleRatio() for the full explanation).
            var size = this.cornerSize * getViewScaleRatio();
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));

            // KP FIX - border-on-hover: only draw the round outline
            // around the icon while the mouse is actually hovering this
            // specific control (this.controlKey, set on the
            // deleteControl/resizeControl Control instances below), not
            // all the time. Drawn as a ring behind the icon image so the
            // icon artwork itself is untouched.
            var isHovered = this.controlKey && hoveredControlKey === this.controlKey;
            if (isHovered) {
                var radius = size / 2;
                ctx.beginPath();
                ctx.arc(0, 0, radius, 0, Math.PI * 2);
                ctx.lineWidth = Math.max(1, size * 0.05);
                ctx.strokeStyle = "#2C485D";
                ctx.stroke();
            }

            ctx.drawImage(icon, -size / 2, -size / 2, size, size);
            ctx.restore();

            // KP FIX - "alt text" style hover tooltip (e.g. "Delete" /
            // "Resize"), drawn AFTER ctx.restore() so it sits in plain
            // canvas space and stays upright even if the object is
            // rotated. this.tooltipText is set alongside controlKey on
            // the Control instances below.
            if (isHovered && this.tooltipText) {
                drawControlTooltip(ctx, left, top - size / 2 - 8, this.tooltipText);
            }
        }
    }

    // KP FIX - keep the custom corner controls (rotate/delete/resize)
    // fully inside the visible canvas. By default a control's icon is
    // centered exactly on the object's corner point, at a fixed pixel
    // size regardless of zoom/scale. That's fine while the object is
    // small, but once the object is scaled up enough that a corner sits
    // near or past the canvas edge, half the icon renders outside the
    // canvas and becomes hard/impossible to click. This wraps a
    // control's default positionHandler (which drives BOTH where the
    // icon is drawn and where clicks are detected, so visuals and
    // hit-testing stay in sync) and nudges the point inward just enough
    // to keep the whole icon on-canvas. It's a no-op whenever the
    // control is already comfortably inside the canvas.
    // KP FIX - returns true for fabric text-type objects (i-text, text,
    // textbox). Used below to nudge the delete/resize icons further away
    // from the object's corner ONLY for text objects, since text has no
    // visual "padding" at the corner the way an image does - without this,
    // the icons render directly on top of the letters.
    function isTextFabricObject(fabricObject) {
        return !!fabricObject && (
            fabricObject.type === 'i-text' ||
            fabricObject.type === 'text' ||
            fabricObject.type === 'textbox'
        );
    }

    function clampControlPositionHandler(textExtraOffset) {
        var defaultPositionHandler = fabric.Control.prototype.positionHandler;
        return function (dim, finalMatrix, fabricObject, currentControl) {
            var point = defaultPositionHandler.call(this, dim, finalMatrix, fabricObject, currentControl);

            var canvasEl = fabricObject && fabricObject.canvas;
            if (!canvasEl) {
                return point;
            }

            // KP FIX - for text objects, push the icon further out along
            // the same diagonal it already sits on (this.x/this.y are the
            // control's corner anchor: -0.5 for top/left, 0.5 for
            // bottom/right), so the delete icon moves further up-left and
            // the resize icon further down-right, clear of the letters.
            // Scaled by getViewScaleRatio() so the gap stays proportionally
            // consistent across zoom levels (e.g. wall view vs sticker view).
            if (textExtraOffset && isTextFabricObject(fabricObject)) {
                var ratio = getViewScaleRatio();
                var dirX = this.x || 0;
                var dirY = this.y || 0;
                point = {
                    x: point.x + Math.sign(dirX) * textExtraOffset * ratio,
                    y: point.y + Math.sign(dirY) * textExtraOffset * ratio
                };
            }

            // KP FIX - icons now render at cornerSize * getViewScaleRatio()
            // (see renderIcon()), so the clamp margin must use that same
            // scaled size, or the icon can still get clamped as if it
            // were full-size and clip past the canvas edge in a
            // zoomed-out view like wall view.
            var half = ((this.cornerSize || 35) * getViewScaleRatio()) / 2;
            var w = canvasEl.getWidth();
            var h = canvasEl.getHeight();

            return {
                x: Math.min(Math.max(point.x, half), Math.max(w - half, half)),
                y: Math.min(Math.max(point.y, half), Math.max(h - half, half))
            };
        };
    }

    // KP - move control (the "move cross"). Sits centered below the
    // object, same size/style as the delete/resize corner controls.
    // Dragging it (or the object body itself, which fabric already
    // supports by default) moves the object. It disappears automatically
    // whenever the object is deselected, exactly like the delete/resize
    // controls, since fabric only draws an object's controls while it's
    // the active selection.
    //
    // positionHandler: anchors at the bottom-center of the object
    // (x:0, y:0.5), then nudges it further down by a fixed gap - scaled
    // by getViewScaleRatio() so the gap stays proportionally the same
    // distance from the object in every view, same idea as
    // scaledOffsetPositionHandler() above - and finally clamps it inside
    // the visible canvas, same as clampControlPositionHandler() does for
    // the corner controls, so it can't render off-screen near the bottom
    // edge.
    function moveControlPositionHandler(gapBelow) {
        return function (dim, finalMatrix, fabricObject, currentControl) {
            var control = currentControl || this;
            var ratio = getViewScaleRatio();
            var savedOffsetX = control.offsetX;
            var savedOffsetY = control.offsetY;
            control.offsetX = 0;
            control.offsetY = gapBelow * ratio;
            var point = fabric.Control.prototype.positionHandler.call(control, dim, finalMatrix, fabricObject);
            control.offsetX = savedOffsetX;
            control.offsetY = savedOffsetY;

            var canvasEl = fabricObject && fabricObject.canvas;
            if (!canvasEl) {
                return point;
            }

            var half = ((control.cornerSize || 35) * ratio) / 2;
            var w = canvasEl.getWidth();
            var h = canvasEl.getHeight();

            return {
                x: Math.min(Math.max(point.x, half), Math.max(w - half, half)),
                y: Math.min(Math.max(point.y, half), Math.max(h - half, half))
            };
        };
    }

    // actionHandler for dragging the move control. transform.original is
    // populated by fabric with the object's left/top at the start of the
    // drag, and transform.ex/ey is the pointer position at that same
    // moment, so (x - transform.ex) / (y - transform.ey) is the total
    // pointer delta since mousedown - added back onto the original
    // left/top this gives the object's new position, the same math
    // fabric uses internally when you drag the object body itself.
    function moveObjectActionHandler(eventData, transform, x, y) {
        var target = transform && transform.target;
        if (!target) {
            return false;
        }

        target.set({
            left: transform.original.left + (x - transform.ex),
            top: transform.original.top + (y - transform.ey)
        });
        target.setCoords();

        // KP - fire the same 'object:moving' event that dragging the
        // object body itself fires, so the existing canvas-bounds clamp
        // and overlap check (see canvas.on('object:moving', ...) near
        // the top of this file) apply here too.
        canvas.fire('object:moving', { target: target, e: eventData, transform: transform });
        canvas.requestRenderAll();
        return true;
    }

    // mouseUpHandler for the move control - fires 'object:modified' when
    // the drag ends, matching what happens when you drag the object body
    // itself.
    function moveObjectMouseUp() {
        var activeObject = canvas.getActiveObject();
        if (activeObject) {
            canvas.fire('object:modified', { target: activeObject });
        }
        return true;
    }

    // KP FIX - the width/height dimension controls (line + "Xcm" label)
    // are anchored a fixed number of pixels away from the object's edge
    // via each Control's offsetX/offsetY (e.g. widthControl's offsetY:48,
    // heightControl's offsetX:-52). Those offsets are applied by fabric's
    // default positionHandler in raw screen pixels, unaffected by canvas
    // zoom - so in wall view they'd sit exactly as far from the object as
    // in sticker view even though the object has visually shrunk to
    // ~0.3x, pushing the line/label far away and making them look
    // oversized/disconnected. This wraps the default positionHandler to
    // scale offsetX/offsetY by getViewScaleRatio() first, so the
    // line/label stay the same proportional distance from the object in
    // every view.
    function scaledOffsetPositionHandler(baseOffsetX, baseOffsetY) {
        return function (dim, finalMatrix, fabricObject, currentControl) {
            var control = currentControl || this;
            var ratio = getViewScaleRatio();
            var savedOffsetX = control.offsetX;
            var savedOffsetY = control.offsetY;
            control.offsetX = baseOffsetX * ratio;
            control.offsetY = baseOffsetY * ratio;
            var point = fabric.Control.prototype.positionHandler.call(control, dim, finalMatrix, fabricObject);
            control.offsetX = savedOffsetX;
            control.offsetY = savedOffsetY;
            return point;
        };
    }

    // async function addCustomRotationControl(controlSize) {
    //     try {
    //         const img = await loadImage("https://cdn.shopify.com/s/files/1/0823/4654/1395/files/refresh.png?v=1718011340");
    //         // Math.min(canvas.width, canvas.height) * 0.05; // 5% of the smallest dimension
    //         var renderData = false;
    //         if (controlSize == undefined) {
    //             renderData = true;
    //             controlSize = 35;
    //         }
    //         img.scaleToWidth(controlSize);
    //         // img.scaleToWidth(25);
    //         const rotationIconDataUrl = img.toDataURL();
    //         const rotationIcon = document.createElement('img');
    //         rotationIcon.src = rotationIconDataUrl;

    //         const mtr = new fabric.Control({
    //             x: 0.5,
    //             y: -0.5,
    //             actionHandler: fabric.controlsUtils.rotationWithSnapping,
    //             cursorStyleHandler: fabric.controlsUtils.rotationStyleHandler,
    //             withConnection: true,
    //             actionName: 'rotate',
    //             cursorStyle: 'pointer',
    //             render: renderIcon(rotationIcon),
    //             positionHandler: clampControlPositionHandler(),
    //             cornerSize: controlSize,
    //         });

    //         fabric.Object.prototype.controls.mtr = mtr;
    //         // Redraw canvas to ensure the control is visible
    //         if (renderData) {
    //             canvas.renderAll();
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    async function loadImage(url) {
        return new Promise((resolve, reject) => {
            fabric.Image.fromURL(url, function (img, isError) {
                if (isError) {
                    reject(isError);
                } else {
                    resolve(img);
                }
            }, { crossOrigin: 'Anonymous' });
        });
    }

    function updateCanvasEmptyState() {
        var objects = canvas.getObjects().filter(function(obj) {
            // Ignore background image if needed
            return obj !== bgData;
        });

        if (objects.length === 0) {
            $('.bg-canvas-holder').addClass('sticker-no-image-upload');
            $('.canvas-editor-note').removeClass('hidden');

            // KP FIX - once the canvas is completely cleared (no photo,
            // no text left), bring back the full default/example state
            // instead of leaving imageheight/imagewidth/textheight/
            // textwidth/the text field blank, so the inputs match the
            // default example preview that's shown again at the same
            // time.
            $('#imageheight').val(DEFAULT_PREVIEW_IMAGE_HEIGHT_CM);
            $('#imagewidth').val(DEFAULT_PREVIEW_IMAGE_WIDTH_CM);
            $('#textheight').val(DEFAULT_PREVIEW_TEXT_HEIGHT_CM);
            $('#textwidth').val(DEFAULT_PREVIEW_TEXT_WIDTH_CM);
            $('#bg_canvas_texttransform').val("").attr('placeholder', DEFAULT_EXAMPLE_TEXT);
            lastValidTransformText = "";

            // KP FIX - the #textheight/#textwidth fields above were being
            // reset back to the DEFAULT_PREVIEW_TEXT_HEIGHT_CM (5cm)
            // example values, but the actual font-size control
            // (#textSizeInput / textScaleSlider) that new text is CREATED
            // with was never reset alongside them. If a text block had
            // been resized larger before being deleted, that oversized
            // font size stuck around and got reused for the next text
            // typed - even though the canvas was fully empty and the
            // height field showed 5cm again. `textFontSize` is the same
            // default (165px) applied on page load, which is what
            // produces the ~5cm default text height, so reuse it here too.
            textSizeInput.value = textFontSize;
            var emptyStateSliderProgress = ((textScaleSlider.value - textScaleSlider.min) / (textScaleSlider.max - textScaleSlider.min)) * 100;
            textScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${emptyStateSliderProgress}%, #3b3b3b ${emptyStateSliderProgress}%)`;

            // KP FIX - same problem as textSizeInput above, but for the
            // Image Size slider (#imagescale). Typing a FIRST text block
            // before any photo was uploaded zeroes this slider out
            // (min/value both set to 0 - see the isFirstTextBlock branch
            // in addText() further down), so the "Resize to fit your
            // space" control clearly shows there's no image yet. But
            // that zeroing was never undone once the canvas emptied back
            // out (e.g. that text block, or a later image, gets
            // deleted) - the slider stayed stuck at 0/0 instead of
            // going back to its normal default (min 2cm, max 100cm,
            // value 70cm - matching DEFAULT_PREVIEW_IMAGE_HEIGHT_CM).
            // Restore those defaults here too, whenever the canvas is
            // fully cleared, so the slider is ready for the next image
            // upload instead of looking broken/disabled at 0.
            imageScaleSlider.min = MIN_IMAGE_SIZE_CM;
            imageScaleSlider.max = MAX_PRINT_SIZE_CM;
            imageScaleSlider.value = DEFAULT_PREVIEW_IMAGE_HEIGHT_CM;
            var emptyStateImageSliderProgress = ((imageScaleSlider.value - imageScaleSlider.min) / (imageScaleSlider.max - imageScaleSlider.min)) * 100;
            imageScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${emptyStateImageSliderProgress}%, #3b3b3b ${emptyStateImageSliderProgress}%)`;

            // KP - once every object has been removed, show the default
            // sticker size (H 70 x W 56 cm) in the "Your Sticker Preview"
            // heading instead of the last-selected object's size.
            resetPreviewSizeHeading();

        } else {
            $('.bg-canvas-holder').removeClass('sticker-no-image-upload');
             $('.canvas-editor-note').addClass('hidden');
        }
    }

    // Define the deleteObject function
    function deleteObject() {
        const activeObject = canvas.getActiveObject();
        if (activeObject) {
            canvas.remove(activeObject);
            canvas.requestRenderAll();
        }

        // KP FIX - canvas.remove() above synchronously fires the
        // 'object:removed' event, which runs updateCanvasEmptyState().
        // If that just emptied the canvas, updateCanvasEmptyState()
        // already restored the correct example defaults for ALL the
        // fields (image height/width, text height/width, and the text
        // value). Only clear the deleted object's own fields below when
        // the canvas still has other objects left - otherwise this was
        // wiping the freshly-restored defaults straight back out.
        var remainingObjects = canvas.getObjects().filter(function (obj) {
            return obj !== bgData;
        });
        var canvasNowEmpty = remainingObjects.length === 0;

        //  enable/disable size slider
        if(canvasNowEmpty){
            $('#imagescale , #textSizeInput').prop('disabled', true);
        }

        if (activeObject && activeObject.type == "i-text") {
            if (!canvasNowEmpty) {
                $('#bg_canvas_texttransform').val("");
                lastValidTransformText = "";
                $('#textheight , #textwidth').val("0");

                // KP FIX - deleting the text while the image remains on
                // the canvas leaves it in the exact same "no text yet"
                // state that the image-upload handler already accounts
                // for (zeroing #textSizeInput when an image is added
                // before any text exists - see hasExistingText check
                // above). So the Text Size slider should be zeroed out
                // the same way here too (min/value both 0), instead of
                // being left stuck at the just-deleted text's old font
                // size. The height/width fields above are correctly
                // cleared to "" already - only the slider itself was
                // missing this reset.
                textSizeInput.min = 0;
                textSizeInput.value = 0;
                textSizeInput.style.background = `linear-gradient(to right, rgb(8, 195, 128) 0%, #3b3b3b 0%)`;
            }
            //  enable/disable size slider
            $('#textSizeInput').prop('disabled', true);
            resetTextData();
        }else if (activeObject && activeObject.type == "image") {
            if (!canvasNowEmpty) {
                $('#imageheight , #imagewidth').val("0");

                // KP FIX - deleting the image while other objects (text)
                // remain on the canvas leaves it in the exact same
                // "no image yet" state that addText() handles when the
                // very first text block is typed before any photo is
                // uploaded - so the Image Size slider (#imagescale)
                // should be zeroed out the same way addText() does it
                // (min/value both 0), instead of being left stuck at
                // the just-deleted image's old size. The height/width
                // fields above are correctly cleared to "" already -
                // only the slider itself was missing this reset.
                imageScaleSlider.min = 0;
                imageScaleSlider.value = 0;
                imageScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) 0%, #3b3b3b 0%)`;
            }
            //  enable/disable size slider
            $('#imagescale').prop('disabled', true);
            resetTextData();
        }
    }


    async function addCustomDeleteControl(controlSize) {
        try {
            //const img = await loadImage("https://cdn.shopify.com/s/files/1/0823/4654/1395/files/delete_button_851c92a4-65a8-4ff2-b2a2-2e5c706cb39a.svg?v=1783684359");
            const img = await loadImage("https://cdn.shopify.com/s/files/1/0823/4654/1395/files/delete_button_2_white_border.svg?v=1785140468");

            var renderData = false;
            if (controlSize == undefined) {
                renderData = true;
                controlSize = 45;
            }

            
            const isMobileResizeIcon = window.innerWidth <= 767;
            controlSize = isMobileResizeIcon ? 20 : controlSize;

            var ControlPositionHandler = isMobileResizeIcon ? 7 : 11;
            img.scaleToWidth(100);
            // img.scaleToWidth(controlSize);

            const deleteIconDataUrl = img.toDataURL();
            const deleteIcon = document.createElement('img');
            deleteIcon.src = deleteIconDataUrl;

            const deleteControl = new fabric.Control({
                x: -0.5, // 539 555
                y: -0.5,
                cursorStyle: 'pointer',
                mouseUpHandler: deleteObject,
                render: renderIcon(deleteIcon),
                // KP FIX - identifies this control to renderIcon()/the
                // mouse:move hover tracker so its border only shows on
                // hover (see hoveredControlKey).
                controlKey: 'deleteControl',
                // KP FIX - hover tooltip text shown above this icon
                // (see drawControlTooltip() / renderIcon()).
                //tooltipText: 'Delete',
                // KP FIX - extra 18px (scaled) pushes the delete icon
                // further up-left, away from the corner, for text objects
                // only, so it doesn't sit on top of the letters (see the
                // "Repositioning delete/expand icons for text objects" fix).
                positionHandler: clampControlPositionHandler(ControlPositionHandler),
                cornerSize: controlSize,
            });

            fabric.Object.prototype.controls.deleteControl = deleteControl;

            if (renderData) {
                // Redraw canvas to ensure the control is visible
                canvas.renderAll();
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function addCustomResizeControl(controlSize) {
        try {
            //const img = await loadImage("https://cdn.shopify.com/s/files/1/0823/4654/1395/files/expand_button_905bd048-6046-417c-afdc-e7b11c138f75.svg?v=1783684361");
            const img = await loadImage("https://cdn.shopify.com/s/files/1/0823/4654/1395/files/expand_button_2_white_border.svg?v=1785140469");
            // Math.min(canvas.width, canvas.height) * 0.05; // 5% of the smallest dimension
            var renderData = false;
            if (controlSize == undefined) {
                renderData = true;
                controlSize = 45;
            }
           // img.scaleToWidth(controlSize);
            // KP FIX - smaller resize icon on mobile so it doesn't overwhelm
            const isMobileResizeIcon = window.innerWidth <= 767;
            controlSize = isMobileResizeIcon ? 20 : controlSize;
            var ControlPositionHandler = isMobileResizeIcon ? 7 : 11;
            img.scaleToWidth(100);
            const resizeIconDataUrl = img.toDataURL();
            const resizeIcon = document.createElement('img');
            resizeIcon.src = resizeIconDataUrl;

            const resizeDataControl = new fabric.Control({
                x: 0.5, // 539 // 0.555
                y: 0.5,
                actionHandler: fabric.controlsUtils.scalingEqually,
                cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
                withConnection: true,
                actionName: 'scale',
                cursorStyle: 'pointer',
                render: renderIcon(resizeIcon),
                // KP FIX - identifies this control to renderIcon()/the
                // mouse:move hover tracker so its border only shows on
                // hover (see hoveredControlKey).
                controlKey: 'resizeControl',
                // KP FIX - hover tooltip text shown above this icon
                // (see drawControlTooltip() / renderIcon()).
                //tooltipText: 'Resize',
                // KP FIX - extra 18px (scaled) pushes the resize icon
                // further down-right, away from the corner, for text
                // objects only, so it doesn't sit on top of the letters
                // (see the "Repositioning delete/expand icons for text
                // objects" fix).
                positionHandler: clampControlPositionHandler(ControlPositionHandler),
                cornerSize: controlSize,
            });

            fabric.Object.prototype.controls.resizeControl = resizeDataControl;
            // Redraw canvas to ensure the control is visible
            if (renderData) {
                canvas.renderAll();
            }
        } catch (error) {
            console.error(error);
        }
    }

     // Draws the round "move cross" button: a white circle with a black
    // outline (same look/size as the delete/expand icons, via
    // this.cornerSize) and a 4-direction arrow glyph in the center.
    function renderMoveIcon(ctx, left, top, styleOverride, fabricObject) {
        var ratio = getViewScaleRatio();

        var isMobileResizeIcon = window.innerWidth <= 767;
       
        var size = this.cornerSize * ratio;
        var size_reduce = isMobileResizeIcon ? 1 : 11;
        size = size - size_reduce;

        var radius = size / 2;
        var radius_increase = isMobileResizeIcon ? 0 : 4;
        radius = radius + radius_increase;

        ctx.save();
        ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));

        // Round button background
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, Math.PI * 2);
        ctx.fillStyle = "#ffffff";
        ctx.fill();

        // KP FIX - border-on-hover: only stroke the circle's outline
        // while the mouse is actually hovering the move control, not by
        // default (hoveredControlKey is set/cleared by the canvas
        // mouse:move listener near the top of the file).
        if (hoveredControlKey === 'moveControl') {
            ctx.lineWidth = Math.max(1, size * 0.05);
            ctx.strokeStyle = "#2C485D";
            ctx.stroke();
        }

        // Arrow settings
        var armLength = size * 0.20; // 0.28
        var headLength = size * 0.16; //0.14
        var headWidth = size * 0.16; // 0.11

        // Adjust this value to increase/decrease the center gap
        var centerGap = size * 0.12;

        ctx.strokeStyle = "#2C485D";
        ctx.fillStyle = "#2C485D";
        ctx.lineWidth = Math.max(1, size * 0.07);
        ctx.lineCap = "round";
        ctx.lineJoin = "square";

        var directions = [
            { dx: 0, dy: -1 }, // Up
            { dx: 0, dy: 1 },  // Down
            { dx: -1, dy: 0 }, // Left
            { dx: 1, dy: 0 }   // Right
        ];

        directions.forEach(function (dir) {

            // Shaft start/end
            var startX = dir.dx * centerGap;
            var startY = dir.dy * centerGap;

            var endX = dir.dx * armLength;
            var endY = dir.dy * armLength;

            // Arrow tip
            var tipX = dir.dx * (armLength + headLength);
            var tipY = dir.dy * (armLength + headLength);

            // Perpendicular direction
            var perpX = -dir.dy;
            var perpY = dir.dx;

            // Draw shaft
            ctx.beginPath();
            ctx.moveTo(startX, startY);
            ctx.lineTo(endX, endY);
            ctx.stroke();

            // Draw arrowhead
            ctx.beginPath();
            ctx.moveTo(tipX, tipY);
            ctx.lineTo(endX + perpX * headWidth, endY + perpY * headWidth);
            ctx.lineTo(endX - perpX * headWidth, endY - perpY * headWidth);
            ctx.closePath();
            ctx.fill();
        });

        ctx.restore();

        // KP FIX - "Move" hover tooltip, drawn AFTER ctx.restore() so
        // it sits in plain canvas space and stays upright even if the
        // object is rotated (same pattern as renderIcon()'s tooltip).
        if (hoveredControlKey === 'moveControl') {
            //drawControlTooltip(ctx, left, top - radius - 8, 'Move');
        }
    }


    // KP - move control ("move cross"): same size/style as the delete
    // and resize controls above, positioned below the object instead of
    // on a corner. controlSize/mobile-size logic mirrors
    // addCustomDeleteControl()/addCustomResizeControl() exactly, so it
    // stays the same size as those on every screen.
    function addCustomMoveControl(controlSize) {
        try {
            var renderData = false;

            if (controlSize == undefined) {
                renderData = true;
                controlSize = 45;
            }
            
            var isMobileResizeIcon = window.innerWidth <= 767;
            controlSize = isMobileResizeIcon ? 20 : controlSize;

            // gap (base pixels) between the object's bottom edge and the
            // move button - scaled by getViewScaleRatio() inside
            // moveControlPositionHandler() so it stays proportionally the
            // same distance away in every view.
            var moveControlGap = isMobileResizeIcon ? 14 : 20; // 20

            var moveControl = new fabric.Control({
                x: 0,
                y: 0.5,
                cursorStyle: 'move',
                actionName: 'drag',
                actionHandler: moveObjectActionHandler,
                mouseUpHandler: moveObjectMouseUp,
                render: renderMoveIcon,
                positionHandler: moveControlPositionHandler(moveControlGap),
                cornerSize: controlSize,
            });

            fabric.Object.prototype.controls.moveControl = moveControl;

            if (renderData) {
                canvas.renderAll();
            }
        } catch (error) {
            console.error(error);
        }
    }

    // addWidthDimentionControls(8, 20, 20, 40, dimentionSize, widthTextTop);
    // addHeightDimentionControls(8, 20, 20, -40, dimentionSize);
    addWidthDimentionControls();
    addHeightDimentionControls();
   // addCustomRotationControl();
    addCustomDeleteControl(30);
    addCustomResizeControl(30);
    addCustomMoveControl(30);

    function addRulers(canvasWidth, canvasHeight) {
        // Add horizontal ruler (X axis)
        var $rulerX = $('#rulerX .ruler');
        $rulerX.empty();
        $rulerX.css('width', canvasWidth + 'px');
        for (let i = 0; i <= canvasWidth; i += cmToPixel(2)) { // Increment by 2 centimeters
            var widthCm = Math.round(i / cmToPixel(1));
            var $span = $('<div class="cm" style="left: ' + i + 'px;width: ' + cmToPixel(2) + 'px;"><span style="font-family:Montserrat BBM !important;font-size: 16px;">' + widthCm + '</span></div>');
            for (let j = 0; j < 9; j++) {
                $span.append('<div class="mm"></div>');
            }
            $rulerX.append($span);
        }

        // Add vertical ruler (Y axis)
        var $rulerY = $('#rulerY .ruler');
        $rulerY.empty();
        $rulerY.css('height', canvasHeight + 'px');
        for (let i = 0; i <= canvasHeight; i += cmToPixel(2)) { // Increment by 2 centimeters
            var heightCm = Math.round(i / cmToPixel(1));
            var $span = $('<div class="cm" style="top: ' + i + 'px;height: ' + cmToPixel(2) + 'px;"><span style="font-family:Montserrat BBM !important;font-size: 16px;">' + heightCm + '</span></div>');
            for (let j = 0; j < 9; j++) {
                $span.append('<div class="mm"></div>');
            }
            $rulerY.append($span);
        }
    }

    // Function to convert centimeters to pixels
    function cmToPixel(cm) {
        return cm * (96 / 2.54); // 96 pixels per inch / 2.54 centimeters per inch
    }

    canvas.on("mouse:down", function (d) { // , touch:gesture
        if (d.target) {
            $('.bg-update-canvas').hide();
            switch (d.target.type) {
                case "text":
                case "i-text":
                    $('#bg_canvas_texttransform').val(d.target.text);
                    lastValidTransformText = d.target.text;
                    updateTextData(d.target);
                    updateTextInputs(d.target);
                    scaleXdata = "";
                    scaleYdata = "";
                    break;
                case "image":
                    $('#bg_canvas_texttransform').val("");
                    lastValidTransformText = "";
                    resetTextData();
                    updateInputs(d.target);
                    scaleXdata = "";
                    scaleYdata = "";
                    //imageScaleSlider.value = 50;
                    //const progress = (50 / sliderEl.max) * 100;
                    //sliderEl.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${progress}%, #ccc ${progress}%)`;
                    break;
                case "group":
                case "circle":
                case "rect":
                    break
                case "line":
                case "triangle":
                case "path-group":
                    break
            }
        } else {
            $('#bg_canvas_texttransform').val("");
            lastValidTransformText = "";
            // resetTextData();
            // SM - deselect active object so next scroll touch isn't captured
            // by Fabric as object manipulation on iOS Safari.
            canvas.discardActiveObject();
        }
        canvas.renderAll();
    });

    


    function pixelsToCentimeters(pixels) {
        var dpi = 96; // Default DPI assumption
        // 1 inch = 2.54 cm
        var inches = pixels / dpi;
        var centimeters = inches * 2.54;
        return centimeters.toFixed(0);
    }

    fabric.Canvas.prototype.removeObjectByName = function (name) {
        var object = null,
            objects = this.getObjects();

        for (var i = 0, len = this.size(); i < len; i++) {
            if (objects[i].name && objects[i].name === name) {
                object = objects[i];
                break;
            }
        }
        if (object != null) {
            canvas.remove(object);
        }
        return true;
    };

    jQuery(".remove-single-image").on('click', function () {
        if (canvas.getActiveObject()) {
            removeDimentionText(canvas.getActiveObject());
            canvas.remove(canvas.getActiveObject());
            $('.image-update-canvas').hide();
        }
    });

    jQuery(".remove-bg").on('click', function (d) {
        d.preventDefault();
        canvas.backgroundImage = null;
        canvas.renderAll();
        bgImage = "";
        $('.bg-update-canvas').hide();
    });

    // Update text properties on change
    fontFamilySelect.addEventListener('change', function () {
        updateTextProperties();
    });
    // KP FIX - removed a duplicate 'input' listener that used to live here
    // (it called updateTextProperties(), which set fontSize directly and
    // fired 'object:scaling' WITHOUT recentering the text first). Because
    // that ran before the proper recentering handler further down
    // (textScaleSlider.addEventListener('input', ...) near the
    // recenterObjectOnRescale KP FIX), the text would grow from its
    // current left/top, hit the canvas edge early on one side, get
    // reverted by the boundary-overflow guard, and the recentering
    // handler would then only ever see that already-reverted (smaller)
    // value. That's why the slider used to stall before reaching 100cm
    // even when there was unused space on the other side. The size
    // slider is now handled exclusively by that single recentering
    // handler, which applies the target size directly and re-centers the
    // text so it always has equal room to grow on both sides.
    $("#bg_canvas_texttransform").on("beforeinput", function (e) {
        if (
            e.originalEvent.data &&
            /[\p{Extended_Pictographic}]/u.test(e.originalEvent.data)
        ) {
            e.preventDefault();
        }
    });

    $("#bg_canvas_texttransform").on("input paste", function () {
        $(this).val(function (_, value) {
            return value.replace(
                /[\p{Extended_Pictographic}\p{Emoji_Presentation}]/gu,
                ""
            );
        });
    });

    textColorInput.addEventListener('input', function () {
        updateTextProperties();
    });
    boldCheckbox.addEventListener('change', function () {
        updateTextProperties();
    });
    italicCheckbox.addEventListener('change', function () {
        updateTextProperties();
    });
    underlineCheckbox.addEventListener('change', function () {
        updateTextProperties();
    });

    // Font support map: true = style is supported (checkbox enabled), false = not supported (checkbox disabled)
    const fontStyleSupport = {
        "Poppins":           { bold: true,  italic: true  },
        "Montserrat":        { bold: true,  italic: true  },
        "Oswald":            { bold: true,  italic: false },
        "Anton":             { bold: false, italic: false },
        "League Spartan":    { bold: true,  italic: false },
        "Lora":              { bold: true,  italic: true  },
        "Playfair Display":  { bold: true,  italic: true  },
        "Alfa Slab One":      { bold: false, italic: false },
        "Fredoka One":       { bold: false, italic: false },
        "Patrick Hand":      { bold: false, italic: false },
        "Quicksand":         { bold: true,  italic: false },
        "Cooper Black":      { bold: false, italic: false },
        "Dancing Script":    { bold: true,  italic: false },
        "Pacifico":          { bold: false, italic: false },
        "Lobster":           { bold: false, italic: false },
        "Permanent Marker":  { bold: false, italic: false },
    };

    function updateTextProperties() {
        // Default to "supported" for any font not in the map, so unlisted fonts aren't accidentally locked
        const family = fontFamilySelect.value;
        const support = fontStyleSupport[family] || { bold: true, italic: true };

        // BOLD: disable checkbox if this font doesn't support bold
        if (!support.bold) {
            boldCheckbox.disabled = true;
            boldCheckbox.checked = false;
        } else {
            boldCheckbox.disabled = false;
        }

        // ITALIC: disable checkbox if this font doesn't support italic
        if (!support.italic) {
            italicCheckbox.disabled = true;
            italicCheckbox.checked = false;
        } else {
            italicCheckbox.disabled = false;
        }

        // KP FIX - fonts load lazily (see ensureFontReady); wait until the
        // requested family/weight/style is actually downloaded before
        // applying it, so the canvas never renders a fallback font.
        ensureFontReady(
            family,
            boldCheckbox.checked ? '700' : '400',
            italicCheckbox.checked ? 'italic' : 'normal'
        ).then(function () {
            const activeObject = canvas.getActiveObject();
            if (activeObject && activeObject.type === 'i-text') {

                 // Store current visual position and scale
                const left = activeObject.left;
                const top = activeObject.top;
                const scaleX = activeObject.scaleX;
                const scaleY = activeObject.scaleY;

                activeObject.set({
                    fontFamily: family,
                    fontSize: parseInt(textSizeInput.value),
                    fill: textColorInput.value,
                    fontWeight: boldCheckbox.checked ? 'bold' : 'normal',
                    fontStyle: italicCheckbox.checked ? 'italic' : 'normal',
                    underline: underlineCheckbox.checked,
                });

                 // IMPORTANT:
                // Recalculate text dimensions after changing font weight/style
                activeObject.initDimensions();

                // Restore position and scale
                activeObject.set({
                    left: left,
                    top: top,
                    scaleX: scaleX,
                    scaleY: scaleY
                });

                activeObject.setCoords();

                canvas.fire('object:scaling', { target: activeObject });
                canvas.renderAll();
                // updateModifications()
            }
        });
    }

    /*function updateTextProperties() {
        const boldFonts = ["Dancing Script", "Droid Sans", "Droid Serif", "Gloria Hallelujah", "Indie Flower", "Lato", "lato", "Lora", "Montserrat", "Open Sans", "Oswald", "PT Sans", "PT Serif", "Pacifico", "Playfair Display", "Raleway", "Roboto", "Roboto Condensed", "Roboto Slab", "Rubik", "Slabo 27px", "Source Sans Pro", "Ubuntu", "Finger Paint", "Teko", "Josefin Sans", "Varela Round", "Berkshire Swash", "Cabin Sketch", "Electrolize", "Niconne", "Reem Kufi", "Love Ya Like A Sister", "Vast Shadow", "Ravi Prakash", "Pirata One", "Great Vibes", "Bree Serif", "Kaushan Script", "Cookie", "Patrick Hand", "Boogaloo", "Playball", "Oleo Script", "Nova Square", "New Rocker"];
        let isFontsBold = false;
        if (boldFonts.includes(fontFamilySelect.value)) {
            isFontsBold = true;
            boldCheckbox.disabled = true;
            boldCheckbox.checked = false;
        } else {
            boldCheckbox.disabled = false;
        }
        const activeObject = canvas.getActiveObject();
        if (activeObject && activeObject.type === 'i-text') {
            activeObject.set({
                fontFamily: fontFamilySelect.value,
                fontSize: parseInt(textSizeInput.value),
                fill: textColorInput.value,
                fontWeight: (boldCheckbox.checked || isFontsBold) ? 'bold' : 'normal',
                fontStyle: italicCheckbox.checked ? 'italic' : 'normal',
                underline: underlineCheckbox.checked,
            });
            canvas.fire('object:scaling', { target: activeObject });
            canvas.renderAll();
            // updateModifications()
        }
    }*/


    // Add text on button click
    // document.getElementById('addTextBtn').addEventListener('click', function () {
    //     const canvasHeight = canvas.getHeight() / canvas.viewportTransform[3];
    //     const additionalValue = (canvasHeight / 6); // Adjust this value as needed
    //     const text = new fabric.IText('Tap and Type', {
    //         left: 100,
    //         top: (canvasHeight / 2) + additionalValue,
    //         fontFamily: fontFamilySelect.value,
    //         fontSize: parseInt(250),
    //         fill: textColorInput.value,
    //         fontWeight: boldCheckbox.checked ? 'bold' : 'normal',
    //         fontStyle: italicCheckbox.checked ? 'italic' : 'normal',
    //         underline: underlineCheckbox.checked,
    //         selectable: true,
    //     });
    //     canvas.add(text);
        
    //     // Set the left position to center the text horizontally
    //     const canvasWidth = canvas.getWidth() / canvas.viewportTransform[0];
    //     const textWidth = text.getScaledWidth();
    //     const centerX = (canvasWidth - textWidth) / 2;
    //     text.set('left', centerX);

    //     canvas.setActiveObject(text);
    //     updateTextInputs(text);
    //     canvas.renderAll();
    // });

    function updateTextData(object) {
        // Update input controls with the selected textbox properties
        fontFamilySelect.value = object.fontFamily;
        sBtn_text.innerText = getFontDisplayName(fontFamilySelect.value);

        textSizeInput.value = object.fontSize;
        textColorInput.value = object.fill;
        $('.bgColorPicker-container .clr-field').css('color', object.fill);
        // boldCheckbox.checked = object.fontWeight === 'bold';
        // const boldFonts = ["Dancing Script", "Droid Sans", "Droid Serif", "Gloria Hallelujah", "Indie Flower", "Lato", "Lora", "Montserrat", "Open Sans", "Oswald", "PT Sans", "PT Serif", "Pacifico", "Playfair Display", "Raleway", "Roboto", "Roboto Condensed", "Roboto Slab", "Rubik", "Slabo 27px", "Source Sans Pro", "Ubuntu", "Finger Paint", "Teko", "Josefin Sans", "Varela Round", "Berkshire Swash", "Cabin Sketch", "Electrolize", "Niconne", "Reem Kufi", "Love Ya Like A Sister", "Vast Shadow", "Ravi Prakash", "Pirata One", "Great Vibes", "Bree Serif", "Kaushan Script", "Cookie", "Patrick Hand", "Boogaloo", "Playball", "Oleo Script", "Nova Square", "New Rocker"];
        // if (boldFonts.includes(fontFamilySelect.value)) {
        //     boldCheckbox.disabled = true;
        //     boldCheckbox.checked = false;
        // } else {
        //     boldCheckbox.checked = object.fontWeight === 'bold';
        // }
        italicCheckbox.checked = object.fontStyle === 'italic';
        underlineCheckbox.checked = object.underline;
    }

    Coloris({
        el: '.bgColorPicker',
        swatches: [
            '#FF0000', '#FFFFFF', '#00FFFF', '#C0C0C0',
            '#0000FF', '#808080', '#000000', '#ADD8E6',
            '#FFA500', '#800080', '#A52A2A', '#FFFF00',
            '#800000', '#00FF00', '#008000', '#FF00FF',
            '#808000', '#FFC0CB',
        ],
    });

    // Undo/Redo
    var myUndoRedoConfig = {
        canvasState: [],
        currentStateIndex: -1,
        undoStatus: false,
        redoStatus: false,
        undoFinishedStatus: 1,
        redoFinishedStatus: 1,
        // undoButton: document.getElementById('undo'),
        // redoButton: document.getElementById('redo'),
    };

    resetUndoRedo();

    function resetUndoRedo() {
        myUndoRedoConfig.canvasState = [];
        myUndoRedoConfig.currentStateIndex = -1;
        myUndoRedoConfig.undoStatus = false;
        myUndoRedoConfig.redoStatus = false;
        myUndoRedoConfig.undoFinishedStatus = 1;
        myUndoRedoConfig.redoFinishedStatus = 1;
        // myUndoRedoConfig.undoButton.disabled = "disabled";
        // myUndoRedoConfig.redoButton.disabled = "disabled";
    }

    function updateModifications() {
        if ((myUndoRedoConfig.undoStatus == false && myUndoRedoConfig.redoStatus == false)) {
            var jsonData = canvas.toJSON();
            var canvasAsJson = JSON.stringify(jsonData);
            if (myUndoRedoConfig.currentStateIndex < myUndoRedoConfig.canvasState.length - 1) {
                var indexToBeInserted = myUndoRedoConfig.currentStateIndex + 1;
                myUndoRedoConfig.canvasState[indexToBeInserted] = canvasAsJson;
                var numberOfElementsToRetain = indexToBeInserted + 1;
                myUndoRedoConfig.canvasState = myUndoRedoConfig.canvasState.splice(0, numberOfElementsToRetain);
            } else {
                myUndoRedoConfig.canvasState.push(canvasAsJson);
            }
            myUndoRedoConfig.currentStateIndex = myUndoRedoConfig.canvasState.length - 1;
            if ((myUndoRedoConfig.currentStateIndex == myUndoRedoConfig.canvasState.length - 1) && myUndoRedoConfig.currentStateIndex != -1) {
                myUndoRedoConfig.redoButton.disabled = "disabled";
            }
            myUndoRedoConfig.undoButton.removeAttribute('disabled');
        }
    }

    var undo = function () {
        if (myUndoRedoConfig.undoFinishedStatus) {
            if (myUndoRedoConfig.currentStateIndex == -1) {
                myUndoRedoConfig.undoStatus = false;
            } else {
                if (myUndoRedoConfig.canvasState.length >= 1) {
                    myUndoRedoConfig.undoFinishedStatus = 0;
                    if (myUndoRedoConfig.currentStateIndex != 0) {
                        myUndoRedoConfig.undoStatus = true;
                        canvas.loadFromJSON(myUndoRedoConfig.canvasState[myUndoRedoConfig.currentStateIndex - 1], function () {
                            var jsonData = JSON.parse(myUndoRedoConfig.canvasState[myUndoRedoConfig.currentStateIndex - 1]);
                            enforceTextNotCanvasEditable();
                            canvas.renderAll();
                            myUndoRedoConfig.undoStatus = false;
                            myUndoRedoConfig.currentStateIndex -= 1;
                            myUndoRedoConfig.undoButton.removeAttribute("disabled");
                            if (myUndoRedoConfig.currentStateIndex !== myUndoRedoConfig.canvasState.length - 1) {
                                myUndoRedoConfig.redoButton.removeAttribute('disabled');
                            }
                            myUndoRedoConfig.undoFinishedStatus = 1;
                        });
                    } else if (myUndoRedoConfig.currentStateIndex == 0) {
                        canvas.clear();
                        myUndoRedoConfig.undoFinishedStatus = 1;
                        myUndoRedoConfig.undoButton.disabled = "disabled";
                        myUndoRedoConfig.redoButton.removeAttribute('disabled');
                        myUndoRedoConfig.currentStateIndex -= 1;
                    }
                }
            }
        }
    }

    var redo = function () {
        if (myUndoRedoConfig.redoFinishedStatus) {
            if ((myUndoRedoConfig.currentStateIndex == myUndoRedoConfig.canvasState.length - 1) && myUndoRedoConfig.currentStateIndex != -1) {
                myUndoRedoConfig.redoButton.disabled = "disabled";
            } else {
                if (myUndoRedoConfig.canvasState.length > myUndoRedoConfig.currentStateIndex && myUndoRedoConfig.canvasState.length != 0) {
                    myUndoRedoConfig.redoFinishedStatus = 0;
                    myUndoRedoConfig.redoStatus = true;
                    canvas.loadFromJSON(myUndoRedoConfig.canvasState[myUndoRedoConfig.currentStateIndex + 1], function () {
                        var jsonData = JSON.parse(myUndoRedoConfig.canvasState[myUndoRedoConfig.currentStateIndex + 1]);
                        enforceTextNotCanvasEditable();
                        canvas.renderAll();
                        myUndoRedoConfig.redoStatus = false;
                        myUndoRedoConfig.currentStateIndex += 1;
                        if (myUndoRedoConfig.currentStateIndex != -1) {
                            myUndoRedoConfig.undoButton.removeAttribute('disabled');
                        }
                        myUndoRedoConfig.redoFinishedStatus = 1;
                        if ((myUndoRedoConfig.currentStateIndex == myUndoRedoConfig.canvasState.length - 1) && myUndoRedoConfig.currentStateIndex != -1) {
                            myUndoRedoConfig.redoButton.disabled = "disabled";
                        }
                    });
                }
            }
        }
    }

    // myUndoRedoConfig.undoButton.addEventListener('click', function () {
    //     undo();
    // });

    // myUndoRedoConfig.redoButton.addEventListener('click', function () {
    //     redo();
    // });

    /* Zoom functions */
    /*function zoomTo(zoom = 1) {
        if (zoom < 0.2) {
            zoom = 0.1
        }
        // if (zoom === 0.7 || zoom === 0.65) {
        //     zoom = 1;
        // }
        var canvasContainer = jQuery(".bg-canvas-wrapper .canvas-container");
        var canvasContainerWidth = canvasContainer.width();
        var canvasContainerHeight = canvasContainer.height();
        var canvasHolderWidth = jQuery(".bg-canvas-holder").outerWidth();
        var canvasHolderHeight = jQuery(".bg-canvas-holder").outerHeight();
        var leftPosition = canvasHolderWidth / 2 - (canvasContainerWidth * zoom) / 2 + 10;
        var topPosition = canvasHolderHeight / 2 - (canvasContainerHeight * zoom) / 2 + 10;
        canvasContainer.css({
            transform: "scale(" + zoom + ")" //,
           // position: "absolute"
        });
        if (canvasHolderWidth < canvasContainerWidth * zoom) {
            leftPosition = 10
        }
        if (canvasHolderHeight < canvasContainerHeight * zoom) {
            topPosition = 10
        }
        canvasContainer.css({
            left: leftPosition,
            top: topPosition
        });
        var zoomdata = zoom.toFixed(1);
        var zoomPercentage = zoomdata * 100;
        jQuery(".zoom-value-hidden").val(zoomdata);
        jQuery(".zoom-value").text(zoomPercentage.toFixed() + '%');
    }*/

    /*jQuery(".zoom-in").on('click', function (d) {
        var zoom = parseFloat(jQuery(".zoom-value-hidden").val()) || 1;
        zoom += 0.1;
        zoomTo(zoom);
    });
    jQuery(".zoom-out").on('click', function (d) {
        var zoom = parseFloat(jQuery(".zoom-value-hidden").val()) || 1;
        zoom -= 0.1;
        zoomTo(zoom);
    });*/

    /*$('.recent-upload .imglist-item:first-of-type').before($('.recent-upload .imglist-item:last-of-type'));
    $('.recent-upload').css('left', '-' + $('.recent-upload .imglist-item:first-of-type').width() + 'px');

    $('.recent-upload-prev').click(function () {
        var a = $('.recent-upload .imglist-item:first-of-type');
        var width = a.width();
        var movement = parseInt($('.recent-upload').css('left')) + width;
        $('.recent-upload:not(:animated)').animate({ 'left': movement + 'px' }, 500, function () {
            $('.recent-upload .imglist-item:first-of-type').before($('.recent-upload .imglist-item:last-of-type'));
            width = $('.recent-upload .imglist-item:first-of-type').width();
            $('.recent-upload').css({ 'left': '-' + width + 'px' });
        });
    });

    $('.recent-upload-next').click(function () {
        var a = $('.recent-upload .imglist-item:nth-child(2)');
        var width = a.width();
        var movement = parseInt($('.recent-upload').css('left')) - width;
        $('.recent-upload:not(:animated)').animate({ 'left': movement + 'px' }, 500, function () {
            $('.recent-upload .imglist-item:last-of-type').after($('.recent-upload .imglist-item:first-of-type'));
            width = $('.recent-upload .imglist-item:first-of-type').width();
            $('.recent-upload').css({ 'left': '-' + width + 'px' });
        });
    });*/

    /* KP - popup before blank add to cart start */
    const cartpopup = document.getElementById("cartpopup");
    const cartpopupcloseBtn = document.querySelector(".cartpopupclose");

    // cartpopupClose the cartpopup when the 'x' is clicked
    cartpopupcloseBtn.onclick = function() {
           cartpopup.style.display = "none";
    };

    // cartpopupClose the cartpopup when clicking outside the cartpopup content
    window.onclick = function(event) {
        if (event.target === cartpopup) {
            cartpopup.style.display = "none";
        }
    };
    /* KP - popup before blank add to cart end*/

        /* KP - popup before blank add to cart start */
    /*const textlimitpopup = document.getElementById("textlimitpopup");
    const textlimitpopupcloseBtn = document.querySelector(".textlimitpopupclose");

    // cartpopupClose the cartpopup when the 'x' is clicked
    textlimitpopupcloseBtn.onclick = function() {
           textlimitpopup.style.display = "none";
    };

    // cartpopupClose the cartpopup when clicking outside the cartpopup content
    window.onclick = function(event) {
        if (event.target === textlimitpopup) {
            textlimitpopup.style.display = "none";
        }
    };*/
    /* KP - popup before blank add to cart end*/

    // KP FIX - see call site in the Add to Cart handler. Builds a
    // detached (never appended to the DOM, never visible) canvas element,
    // loads the same objects onto it via JSON, sizes it to the full
    // print resolution with an identity viewport transform, exports a
    // dataURL from THAT, then throws it away. The customer's actual
    // on-screen canvas is never resized or otherwise touched.
    function exportHighResCanvasDataURL(sourceCanvas, newWidth, newHeight, exportOptions) {
        return new Promise((resolve, reject) => {
            try {
                var offscreenEl = document.createElement('canvas');
                var offscreenCanvas = new fabric.StaticCanvas(offscreenEl, {
                    width: newWidth,
                    height: newHeight
                });

                offscreenCanvas.loadFromJSON(sourceCanvas.toJSON(), function () {
                    offscreenCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
                    offscreenCanvas.renderAll();
                    var dataURL = offscreenCanvas.toDataURL(exportOptions);
                    offscreenCanvas.dispose();
                    resolve(dataURL);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    $('#add-to-cart-item').on('click', async function (e) {
        var alertContent = "";
        if (canvas.getObjects().length < 1) {
            cartpopup.style.display = "flex"; // KP - popup before blank add to cart start
            return false;
        }

        // KP FIX - always switch to sticker-view before computing the real
        // size / exporting the cart image. Previously, clicking Add to Cart
        // while wall-view was active exported/measured the canvas as it sat
        // in wall-view's zoomed-out, padded state, instead of the plain
        // product (sticker) view. Forcing sticker-view here first means the
        // real size data and the exported image sent to cart/checkout always
        // reflect the same, consistent (non-wall) view.
        if (!jQuery('#sticker-view-btn').hasClass('active')) {
            jQuery('#sticker-view-btn').trigger('click');
        }

        $('.bg-loader').show();
        var objs = canvas.getObjects();
        var exportDataTmp = {};
        var exportDataImageTmp = {};
        var textObjecttitle = '';
        var textObjectcontent = '';
        var MainTitle = 'Your Custom Wall Sticker Details';
        var Maincontent = 'NULL';
        var ImageObjecttitle = '';
        var ImageObjectcontent = 'NULL';
        var exportData = {};
        var exportDataImagetitle = {};
        var heightWidthData = "";
        // Loop through each object and log its data
        let textCount = 1;
        objs.forEach(function(obj, index) {
            const scale = canvas.viewportTransform[0];
            // Get the height in centimeters
            var scaledHeight = obj.height * obj.scaleY;
            var scaledWidth = obj.width * obj.scaleX;
            heightWidthData = "Width: "+pixelsToCentimeters(scaledWidth) + 'cm'+", Height: "+pixelsToCentimeters(scaledHeight) + 'cm';
            if (obj.type == "image") {
                let imageDimensions = "Dimensions";
                exportDataImageTmp = {...exportDataImageTmp, ...{ [imageDimensions]: heightWidthData }};
                ImageObjecttitle = 'Photo';
            }else if (obj.type == "i-text") {
                let textObjectKey = '';
                let DimentionObjectKey ='';
                let textContentData = "'"+obj.text+"'";
                let textDimentionData = heightWidthData+" | Font: "+obj.fontFamily;
                if(textCount == 1){
                    textObjecttitle = "Text";
                    textObjectcontent = " "; 
                    textObjectKey = "Quote_"+textCount;    
                    DimentionObjectKey = "Dimensions_"+textCount;    
                }else{
                    textObjectKey = "Quote_"+textCount;    
                    DimentionObjectKey = "Dimensions_"+textCount;    
                }
                exportDataTmp = {...exportDataTmp,...{[textObjecttitle]: textObjectcontent }, ...{ [textObjectKey]: textContentData },...{[DimentionObjectKey]: textDimentionData}};
                textCount++;                
            }
        });

        var realSizeData = calculateRealSize(canvas);
        var newWidth = cmToPixel(realSizeData.width);
        var newHeight = cmToPixel(realSizeData.height);

        /*if (canvas.width !== newWidth || canvas.height !== newHeight) {
            canvas.setDimensions({ width: newWidth, height: newHeight });
            canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
            canvas.renderAll();
        }*/


        var exportOptions = {
            format: 'png',
            quality: 1 // Reduced quality for performance
        };
        //var canvasDataURL = canvas.toDataURL(exportOptions);

        // KP FIX - this used to resize the LIVE, on-screen canvas element
        // itself (canvas.setDimensions) up to full print resolution just
        // to export a high-res image, then never sized it back down
        // before the page redirected to /cart - so customers would
        // visibly see their canvas balloon up (e.g. 778px -> ~3550px)
        // right as they clicked Add to Cart. Now the high-res image is
        // rendered on a separate, invisible canvas built from the same
        // objects, so the visible canvas never changes size at all.
        var canvasDataURL = await exportHighResCanvasDataURL(canvas, newWidth, newHeight, exportOptions);

        // Create a new worker with an absolute path // not working
        // var worker = new Worker("//inspirewallsticker.com/cdn/shop/t/39/assets/blobWorker.js?v=114813312301117022731784612172");

        // The resource is stored in variable in get-started-now.liquid // not working
        var worker = new Worker(shopifyWorker);

        // static relative path // working
        // var worker = new Worker("/cdn/shop/t/34/assets/blobWorker.js?v=114813312301117022731781173541");

        worker.postMessage({ dataURL: canvasDataURL });
        worker.onmessage = function (e) {
            var blob = e.data;

            const formData = new FormData();
            formData.append('image', blob, 'canvas_image.png');
            formData.append('canvasSize', realSizeData.width + 'x' + realSizeData.height);
            // Send the image to the PHP file via AJAX
            $.ajax({
                url: 'https://inspirewallsticker.photos/productapi.php',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (!response.id || !response.real_image) {
                        console.error('Invalid response from API:', response);
                        $('.bg-loader').hide();
                        return;
                    }
                    // exportDataImagetitle = {...{[MainTitle]: [Maincontent]},...{ [ImageObjecttitle]: [ImageObjectcontent]}};
                    exportDataImagetitle = {...{ [ImageObjecttitle]: [ImageObjectcontent]}};
                    exportData = { Preview: response.real_image };
                  if (ImageObjecttitle == ""){
                    exportData = {...exportData,...exportDataImageTmp, ...exportDataTmp};
                  } else {
                    exportData = {...exportDataImagetitle,...exportData,...exportDataImageTmp, ...exportDataTmp};
                  }
                    jQuery.ajax({
                      url: window.routes.cart_add_url,
                      type: 'POST',
                      data: {
                          quantity: 1,
                          id: response.id,
                          properties: exportData
                      },
                      success: function (result) {
                          window.location.href = window.routes.cart_url;
                          $('.bg-loader').hide();
                      },
                      error: function (jqxhr, status, exception) {
                          if (jqxhr.status == 200) {
                              window.location.href = window.routes.cart_url;
                          }
                          $('.bg-loader').hide();
                      }
                  });
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.error('Error saving image to Shopify:', textStatus, errorThrown);
                    $('.bg-loader').hide();
                }
            });
        };
    });

    /* Image scaling feature */
    const imageScaleSlider = document.getElementById('imagescale');
    const imageWidthInput = document.getElementById('imagewidth');
    const imageHeightInput = document.getElementById('imageheight');
    const textScaleSlider = document.getElementById('textSizeInput');
    const textWidthInput = document.getElementById('textwidth');
    const textHeightInput = document.getElementById('textheight');

    let originalWidth, originalHeight, textOriginalWidth, textOriginalHeight;

    /* KP FIX - Image/Text size slider overhaul.
       ------------------------------------------------------------
       Problem 1: dragging the slider needed several attempts to reach
       the size you wanted. The old image-slider handler only ever
       nudged the object by a fixed +/-1/30 of its CURRENT size on
       every 'input' tick (comparing the new slider position to the
       previous one), instead of jumping straight to the size the
       slider position actually represents. A single drag gesture
       doesn't fire enough 'input' ticks for that nudge to add up to
       the full range, so users had to release and drag again.

       Problem 2: the slider could show 100% while the object was
       nowhere near the maximum 100 x 100cm print size. The slider's
       right-hand end was always treated as "100", but the object grows
       from its fixed top-left corner - so if it wasn't sitting flush
       against the top-left of the canvas (e.g. centred, with unused
       space on the left), it would hit the canvas edge on one side and
       get reverted well before reaching its true maximum size.

       Fix: on every selection/update we recalculate the object's real
       maximum size, capped only by the 100 x 100cm print size, and use
       that as the slider's max. The sliders now also RE-CENTRE the
       object around its own centre point as it grows or shrinks
       (instead of only expanding right/down from its top-left corner),
       so it always has equal room on every side and can actually reach
       that true maximum - and applies its exact size directly (not
       incrementally), so one drag is always enough. */

    // Largest size (any side) we will ever print, in cm - matches the
    // "up to 100 x 100 cm" copy shown elsewhere in this tool.
    var MAX_PRINT_SIZE_CM = 100;
    // Smallest sensible size we'll let an image shrink to (cm), so it
    // can never be dragged down to nothing.
    var MIN_IMAGE_SIZE_CM = 2;
    // Smallest sensible text size (px), so text can never be dragged
    // down to unreadable/invisible.
    var MIN_TEXT_FONT_SIZE_PX = 20;

    // Computes the true maximum WIDTH (cm) the given image object can
    // ever reach, capped only by the 100cm print size (position is
    // handled separately by re-centering the object as it grows, so it
    // is never blocked by unused space on one particular side).
    function computeMaxImageWidthCm(obj) {
        if (!obj || !originalWidth || !originalHeight) {
            return MAX_PRINT_SIZE_CM;
        }

        var maxPrintPx = cmToPixel(MAX_PRINT_SIZE_CM);
        var maxScale = maxPrintPx / Math.max(originalWidth, originalHeight);
        return Math.max(parseFloat(pixelsToCentimeters(originalWidth * maxScale)), MIN_IMAGE_SIZE_CM);
    }

    // Computes the true maximum font size (px) the given text object can
    // ever reach, capped only by the 100cm print size (position is
    // handled separately by re-centering the object as it grows, so it
    // is never blocked by unused space on one particular side).
    function computeMaxTextFontSize(obj) {
        var fallbackMax = parseFloat(textScaleSlider && textScaleSlider.max) || 800;
        if (!obj || !obj.fontSize) {
            return fallbackMax;
        }

        var currentFontSize = obj.fontSize;
        var scaleX = obj.scaleX || 1;
        var scaleY = obj.scaleY || 1;
        // How many px of width/height this text needs per unit of
        // fontSize, at its current wrapping - used to translate the
        // available pixel space back into a fontSize.
        var widthPerUnit = (obj.width * scaleX) / currentFontSize;
        var heightPerUnit = (obj.height * scaleY) / currentFontSize;

        if (!widthPerUnit || !heightPerUnit) {
            return fallbackMax;
        }

        var maxPrintPx = cmToPixel(MAX_PRINT_SIZE_CM);
        var maxFontSize = Math.min(maxPrintPx / widthPerUnit, maxPrintPx / heightPerUnit);

        // Never report a max below the object's current size - it's
        // already on canvas at that size, so it must be achievable.
        return Math.max(Math.floor(maxFontSize), currentFontSize);
    }

    // KP FIX - re-centers obj around its current center point after its
    // scale/fontSize has just been changed, then clamps it fully onto
    // the (fixed, 100cm) canvas. Called by the size sliders so growing
    // or shrinking an object always uses space on BOTH sides evenly,
    // instead of only the side it happens to have left/top room on -
    // otherwise an off-center object could hit the canvas edge (and get
    // reverted by the boundary-overflow guard) well before reaching the
    // size the slider position represents.
    function recenterObjectOnRescale(obj, oldScaledWidth, oldScaledHeight, oldLeft, oldTop) {
        var centerX = oldLeft + oldScaledWidth / 2;
        var centerY = oldTop + oldScaledHeight / 2;

        obj.setCoords();
        var newScaledWidth = obj.width * (obj.scaleX || 1);
        var newScaledHeight = obj.height * (obj.scaleY || 1);

        var newLeft = centerX - newScaledWidth / 2;
        var newTop = centerY - newScaledHeight / 2;

        newLeft = Math.min(Math.max(newLeft, 0), Math.max(canvas_width - newScaledWidth, 0));
        newTop = Math.min(Math.max(newTop, 0), Math.max(canvas_height - newScaledHeight, 0));

        obj.set({ left: newLeft, top: newTop });
        obj.setCoords();
    }
    /* KP FIX - Image/Text size slider overhaul end */

    /* KP - "Your Sticker Preview" heading dimension display.
       Shows the height/width (in cm) of whichever object (image or
       text) is currently selected, along with the matching
       "Image Size :" / "Text Size :" label.
       - Image or text selected -> visible, showing that object's size.
       - Nothing selected (e.g. after clicking "Done"), but objects
         still on canvas -> stays visible, still showing the size of
         the last active object.
       - Canvas fully cleared -> visible, showing the default image
         size (H 70 x W 56 cm). */
    var DEFAULT_PREVIEW_IMAGE_HEIGHT_CM = 70;
    var DEFAULT_PREVIEW_IMAGE_WIDTH_CM = 56;
    var DEFAULT_PREVIEW_TEXT_HEIGHT_CM = 5;
    var DEFAULT_PREVIEW_TEXT_WIDTH_CM = 26;
    var DEFAULT_EXAMPLE_TEXT = "Every champion starts somewhere.";

    var $previewSizeWrap = $('.preview-sticker-dimention');
    var $previewImageTitle = $('#previewimagetitle');
    var $previewTextTitle = $('#previewtexttitle');
    var $previewHeight = $('#previewheight');
    var $previewWidth = $('#previewWidth');

    function updatePreviewSizeHeading(objType, heightCm, widthCm) {
        $previewHeight.text(heightCm);
        $previewWidth.text(widthCm);

        if (objType === 'text' || objType === 'i-text') {
            $previewTextTitle.removeClass('hidden');
            $previewImageTitle.addClass('hidden');
        } else {
            $previewImageTitle.removeClass('hidden');
            $previewTextTitle.addClass('hidden');
        }

        // an object is selected (or canvas was cleared) - show the block
        $previewSizeWrap.removeClass('hidden');
    }

    // Nothing selected, but objects may still be on the canvas - hide
    // the size block entirely.
    function hidePreviewSizeHeading() {
        $previewSizeWrap.addClass('hidden');
    }

    // Canvas fully cleared of objects - show the default image size.
    function resetPreviewSizeHeading() {
        updatePreviewSizeHeading('image', DEFAULT_PREVIEW_IMAGE_HEIGHT_CM, DEFAULT_PREVIEW_IMAGE_WIDTH_CM);
    }

    // Nothing is selected on load - start hidden
    //hidePreviewSizeHeading();
    /* KP - "Your Sticker Preview" heading dimension display end */

    // Ensure both width and height are updated to maintain aspect ratio
    canvas.on('object:scaling', function () {
        const activeObj = canvas.getActiveObject();
        if (activeObj.type == "image") {       
            updateInputs(activeObj);
        } else if (activeObj.type == "i-text") {
            updateTextInputs(activeObj);
        }
    });
    canvas.on('object:added', function (currentObj) {
        if (currentObj.target.type == "image") {
            originalWidth = currentObj.target.width;
            originalHeight = currentObj.target.height;
        } else if (currentObj.target.type == "i-text") {
            textOriginalWidth = currentObj.target.width;
            textOriginalHeight = currentObj.target.height;
        }

        //kk object overlap check 9-6-26 
        checkObjectOverlap();
        //kk object overlap check 9-6-26

        // check canvas is empty or not 
        updateCanvasEmptyState();
    });
    
    //kk object overlap check 9-6-26 
    canvas.on('object:removed', checkObjectOverlap);
    //kk object overlap check 9-6-26 

     // check canvas is empty or not 
    canvas.on('object:removed', updateCanvasEmptyState);
   
    function updateTextInputs(text) {
        var textWidth = text.width * text.scaleX;
        var textHeight = text.height * text.scaleY;
        textWidthInput.value = pixelsToCentimeters(textWidth);
        textHeightInput.value = pixelsToCentimeters(textHeight);

        // KP - keep the "Your Sticker Preview" heading in sync with the
        // currently selected text's size
        updatePreviewSizeHeading('text', textHeightInput.value, textWidthInput.value);

        // KP FIX - recalculate the slider's true achievable max (based on
        // the text's CURRENT position/size on the canvas) every time we
        // sync, so the slider's right-hand end always represents a
        // genuinely reachable size instead of a fixed guess.
        textScaleSlider.max = computeMaxTextFontSize(text);
        if (parseFloat(textScaleSlider.min) > MIN_TEXT_FONT_SIZE_PX) {
            textScaleSlider.min = MIN_TEXT_FONT_SIZE_PX;
        }
        textScaleSlider.value = text.fontSize;

        const progress = (textScaleSlider.value / textScaleSlider.max) * 100;

        textScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${progress}%, #3b3b3b ${progress}%)`;
        //  enable/disable size slider
        $('#textSizeInput').prop('disabled', false);

        /* KP - hide control while typing text */
         // KP - Show controls after typing stops
        debounce(() => {
            text.set({
                hasControls: true,
                hasBorders: true,
                lockScalingFlip: true,
                flipX: false,
                flipY: false
            });
            canvas.renderAll(); // Re-render the canvas
        }, 400); // KP - Adjust debounce delay as needed
        /* KP - hide control while typing text functionality*/

        //kk object overlap check 9-6-26 
        checkObjectOverlap();
        //kk object overlap check 9-6-26
    }

    function updateInputs(img) {
        var imgWidth = img.width * img.scaleX;
        var imgHeight = img.height * img.scaleY;
        imageWidthInput.value = pixelsToCentimeters(imgWidth);
        imageHeightInput.value = pixelsToCentimeters(imgHeight);

        var imgactualwidth = pixelsToCentimeters(imgWidth);
        var imgactualheight = pixelsToCentimeters(imgHeight);
        var remainingwidth = 100 - imgactualwidth;

        // KP FIX - recalculate the slider's true achievable max (based on
        // the image's CURRENT position/size on the canvas) every time we
        // sync, so the slider's right-hand end always represents a
        // genuinely reachable size instead of assuming 100cm is always
        // reachable regardless of position/aspect ratio.
        imageScaleSlider.max = computeMaxImageWidthCm(img);
        if (parseFloat(imageScaleSlider.min) > MIN_IMAGE_SIZE_CM) {
            imageScaleSlider.min = MIN_IMAGE_SIZE_CM;
        }
        imageScaleSlider.value = imgactualwidth;

        var imgSliderProgress = (imageScaleSlider.value / imageScaleSlider.max) * 100;
        imageScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${imgSliderProgress}%, #3b3b3b ${imgSliderProgress}%)`;

        // KP - keep the "Your Sticker Preview" heading in sync with the
        // currently selected image's size
        updatePreviewSizeHeading('image', imgactualheight, imgactualwidth);
         /*const progress = (imageScaleSlider.value / imageScaleSlider.max) * 100;
         const minus_progress = imageScaleSlider.max - progress;
        imageScaleSlider.style.background = `linear-gradient(to right, #0d6efd ${progress}%, #ccc ${minus_progress}%)`;*/

        //kk object overlap check 9-6-26 
        checkObjectOverlap();
        //kk object overlap check 9-6-26
    }

    // KP FIX - text size slider: apply the selected font size directly
    // and absolutely (not incrementally) so a single drag always lands
    // exactly on the size the slider position represents, and
    // re-centre the text as it grows/shrinks so it isn't blocked by
    // unused space on one particular side of the canvas.
    textScaleSlider.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (activeObj && activeObj.type == "i-text") {
            const targetFontSize = parseInt(textScaleSlider.value, 10);
            if (!isNaN(targetFontSize)) {
                const oldScaledWidth = activeObj.width * (activeObj.scaleX || 1);
                const oldScaledHeight = activeObj.height * (activeObj.scaleY || 1);
                const oldLeft = activeObj.left;
                const oldTop = activeObj.top;

                activeObj.set({ fontSize: targetFontSize });
                recenterObjectOnRescale(activeObj, oldScaledWidth, oldScaledHeight, oldLeft, oldTop);

                canvas.fire('object:scaling', { target: activeObj });
                canvas.renderAll();
            }
            updateTextInputs(activeObj);
        }
    });

    // Event listener for width input
    // KP - linked proportional resize: width drives height (matches slider/drag-resize uniform scaling)
    textWidthInput.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (parseFloat(textWidthInput.value) > 100) {
            textWidthInput.value = 100;
        }
        if (activeObj && activeObj.type == "i-text") {
            const newWidthPx = cmToPixel(parseFloat(textWidthInput.value));
            const scaleFactor = newWidthPx / activeObj.width;
            activeObj.scaleX = scaleFactor;
            activeObj.scaleY = scaleFactor;
            scaleXdata = "";
            scaleYdata = "";
            canvas.fire('object:scaling', { target: activeObj });
            canvas.renderAll();
            updateTextInputs(activeObj);
        }
    });

    // Event listener for height input
    // KP - linked proportional resize: height drives width (matches slider/drag-resize uniform scaling)
    textHeightInput.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (parseFloat(textHeightInput.value) > 100) {
            textHeightInput.value = 100;
        }
        if (activeObj && activeObj.type == "i-text") {            
            const newHeightPx = cmToPixel(parseFloat(textHeightInput.value));
            const scaleFactor = newHeightPx / activeObj.height;
            activeObj.scaleX = scaleFactor;
            activeObj.scaleY = scaleFactor;
            scaleXdata = "";
            scaleYdata = "";
            canvas.fire('object:scaling', { target: activeObj });
            canvas.renderAll();
            updateTextInputs(activeObj);
        }
    });

    // KP FIX - image size slider: apply the selected width directly and
    // absolutely (not incrementally) so a single drag always lands
    // exactly on the size the slider position represents, and
    // re-centre the image as it grows/shrinks so it isn't blocked by
    // unused space on one particular side of the canvas. 100% (the
    // slider's max, kept in sync by computeMaxImageWidthCm) always
    // means the image's true maximum size.
    imageScaleSlider.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (activeObj && activeObj.type == "image" && originalWidth) {
            const targetWidthCm = parseFloat(imageScaleSlider.value);
            if (!isNaN(targetWidthCm)) {
                const newWidthPx = cmToPixel(targetWidthCm);
                const scaleFactor = newWidthPx / originalWidth;

                const oldScaledWidth = activeObj.width * activeObj.scaleX;
                const oldScaledHeight = activeObj.height * activeObj.scaleY;
                const oldLeft = activeObj.left;
                const oldTop = activeObj.top;

                activeObj.scaleX = scaleFactor;
                activeObj.scaleY = scaleFactor;
                recenterObjectOnRescale(activeObj, oldScaledWidth, oldScaledHeight, oldLeft, oldTop);

                canvas.fire('object:scaling', { target: activeObj });
                canvas.renderAll();
                updateInputs(activeObj);
            }
        }
    });


    /* KP - Image resize slider */
    /*imageScaleSlider.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
      
        if (activeObj && activeObj.type === "image") {
            // Get the slider value and normalize it
            const scaleFactor = imageScaleSlider.value / 100;
            console.log(scaleFactor);
            // Apply the scale while ensuring it stays within limits
            resizeObject(activeObj, scaleFactor);
           // console.log(imageScaleSlider.value);
            //console.log(scaleFactor);
            // updateInputs(activeObj);
        }
    });

    function resizeObject(object, scaleFactor) {
        // Limit scaleFactor to a minimum and maximum
        const minScale = 0.1; // Minimum scale (10%)
        const maxScale = 3;   // Maximum scale (300%)

        const newScale = Math.min(Math.max(scaleFactor, minScale), maxScale);
        console.log("scaleFactor"+scaleFactor);
        object.scaleX = newScale;
        object.scaleY = newScale;

        console.log("newScale"+newScale);
        console.log("object.scaleX"+object.scaleX);
        console.log("object.scaleY"+object.scaleY);
        // Notify canvas and re-render
        canvas.fire('object:scaling', { target: object });
        canvas.renderAll();
    }*/
    /* KP - Image resize slider */

    // Event listener for width input
    // KP - linked proportional resize: width drives height (matches slider/drag-resize uniform scaling)
    imageWidthInput.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (parseFloat(imageWidthInput.value) > 100) {
            imageWidthInput.value = 100;
        }
        if (activeObj && activeObj.type == "image") {            
            const newWidthPx = cmToPixel(parseFloat(imageWidthInput.value));
            const scaleFactor = newWidthPx / originalWidth;
            activeObj.scaleX = scaleFactor;
            activeObj.scaleY = scaleFactor;
            scaleXdata = "";
            scaleYdata = "";
            canvas.fire('object:scaling', { target: activeObj });
            canvas.renderAll();
            updateInputs(activeObj);
        }
    });

    // Event listener for height input
    // KP - linked proportional resize: height drives width (matches slider/drag-resize uniform scaling)
    imageHeightInput.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (parseFloat(imageHeightInput.value) > 100) {
            imageHeightInput.value = 100;
        }
        if (activeObj && activeObj.type == "image") {            
            const newHeightPx = cmToPixel(parseFloat(imageHeightInput.value));
            const scaleFactor = newHeightPx / originalHeight;
            activeObj.scaleX = scaleFactor;
            activeObj.scaleY = scaleFactor;
            scaleXdata = "";
            scaleYdata = "";
            canvas.fire('object:scaling', { target: activeObj });
            canvas.renderAll();
            updateInputs(activeObj);
        }
    });

    /* KP FIX - the image/text size sliders' fill-bar gradient is now kept
       in sync directly inside updateInputs()/updateTextInputs() and the
       sliders' own 'input' handlers above (which also recompute the
       true achievable max on every update), so the separate duplicate
       gradient-only listeners that used to live here have been removed
       to avoid multiple handlers fighting over the same slider.
       Just paint the initial fill once on load, from whatever default
       value/min/max the sliders start with. */
    (function initSliderGradient(el) {
        var p = ((el.value - el.min) / (el.max - el.min)) * 100;
        el.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${p}%, #3b3b3b ${p}%)`;
    })(imageScaleSlider);
    (function initSliderGradient(el) {
        var p = ((el.value - el.min) / (el.max - el.min)) * 100;
        el.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${p}%, #3b3b3b ${p}%)`;
    })(textScaleSlider);

    /* KP - hide control while typing text functionality*/
    // KP - Debounce function to delay showing controls while typing text
    let typingTimeout;
    function debounce(func, delay) {
      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(func, delay);
    }
    // KP - Debounce function to delay showing controls while typing text
    /* KP - hide control while typing text functionality*/

   // $("#bg_canvas_texttransform").on('change keyup paste', function (d) { // 
    document.getElementById('bg_canvas_texttransform').addEventListener('input', function(e) {
        $(".canvas-sticker-note").addClass("hidden");
        var transformText = jQuery(this).val();

        if (transformText != "" && transformText.trim() != "") {
            var activeObject = canvas.getActiveObject();
            if (activeObject) {
                if (activeObject.type === 'i-text') {
                     const wrappedText = wrapCanvasText(transformText, canvas, activeObject);

                    // KP FIX - stop typing / pasting once the text box
                    // would grow past the bottom of the canvas. Revert
                    // the input back to the last value that fit, alert
                    // the user, and don't touch the canvas object.
                    if (willTextOverflowCanvas(wrappedText, activeObject)) {
                        this.value = lastValidTransformText;
                        jQuery('#textlimitModal').modal('show');
                        return;
                    }
                    lastValidTransformText = transformText;

                   /* KP - hide control while typing text functionality*/
                   // KP - Hide controls and borders
                    canvas.getActiveObject().set({
                        hasControls: false,
                        hasBorders: false,
                    });
                    canvas.renderAll();
                    /* KP - hide control while typing text functionality*/

                    /*Temporary image add class  in sticker*/
                     $(".bg-editor-canvas").removeClass("sticker-no-image-upload");
                    /*Temporary image add class  in sticker*/
                    
                    canvas.getActiveObject().set("text", wrappedText);
                    keepTextInsideCanvasHorizontally(wrappedText, canvas.getActiveObject());
                    canvas.renderAll();
                    updateTextInputs(canvas.getActiveObject());

                } else {
                    addText(transformText);
                    lastValidTransformText = transformText;
                }
            } else {
                // KP FIX - remember whether this is the very first thing
                // being added to an empty canvas (still showing the
                // "no-upload-image" / "page-started-wall-view" state).
                // Previously we just stripped these classes and fell back
                // to whatever zoom the canvas already had - which is the
                // plain sticker-view scale, since showWallView() is never
                // called until something explicitly triggers it. That
                // made the very first typed text render at normal/full
                // size instead of the zoomed-out wall-view scale that
                // canvas_add_image() already applies for a first image.
                var isFirstContent = jQuery(".bg-editor-canvas").hasClass("no-upload-image") ||
                    jQuery(".bg-editor-canvas").hasClass("page-started-wall-view");

                jQuery(".bg-editor-canvas").removeClass("page-started-wall-view no-upload-image");
                 /*Temporary image add class  in sticker*/
                 $(".bg-editor-canvas").removeClass("sticker-no-image-upload");
                /*Temporary image add class  in sticker*/
                jQuery(".canvas-editor-note").addClass("hidden");
                addText(transformText);
                lastValidTransformText = transformText;

                if (isFirstContent) {
                    // Mirror canvas_add_image(): actually apply the
                    // wall-view zoom (not just the CSS classes) so the
                    // newly typed text is scaled down to match.
                    jQuery('#wall-view-btn').trigger('click');
                }
            }

            //  enable/disable size slider
            $('#textSizeInput').prop('disabled', false);

        } else {
            lastValidTransformText = "";
            let acObj = canvas.getActiveObject();
            if (acObj && acObj.type === 'i-text') {
                canvas.remove(acObj);

                // clear input field when we delete text from input box using backspace key.
                if(transformText == ""){
                    $('#textheight').val('0');
                    $('#textwidth').val('0');

                    $('#textSizeInput').val(0).prop('min', 0);

                    $('#textSizeInput').css('background','linear-gradient(to right, rgb(8, 195, 128) 0%, #3b3b3b 0%)');
                    //  enable/disable size slider
                    $('#textSizeInput').prop('disabled', true);
                }
            }


            

        }
    });

    // KP FIX - fabric.IText's default JSON serialization does not
    // guarantee the `editable` flag survives a round trip through
    // canvas.toJSON()/loadFromJSON() (used by undo/redo below). Call
    // this right after any loadFromJSON so restored text objects always
    // stay locked to "edit via the outside input field only", even if a
    // stale/older canvasState entry (saved before this fix) didn't have
    // editable:false baked in.
    function enforceTextNotCanvasEditable() {
        canvas.getObjects().forEach(function (obj) {
            if (obj.type === 'i-text' || obj.type === 'text' || obj.type === 'textbox') {
                obj.editable = false;
                if (obj.isEditing) {
                    obj.exitEditing();
                }
            }
        });
    }

    function addText(transformText) {
        // KP FIX - reset the Colour swatch to black explicitly whenever
        // new text is added, matching resetTextData()'s existing reset
        // behaviour. Done here before the fabric.IText below is created
        // so the new text object itself also renders black by default.
        //textColorInput.value = "#000000";
        //$('.bgColorPicker-container .clr-field').css('color', "#000000");
        $('#bg_canvas_texttransform').attr('placeholder', '');

        // KP FIX - text position must be calculated in the canvas' fixed
        // logical (model) space, i.e. the 100cm square, NOT the current
        // on-screen pixel size divided by whatever zoom is active.
        // canvas.getHeight() is the actual (small) rendered canvas element
        // size, and canvas.viewportTransform[3] is the CURRENT view zoom
        // (which includes the extra 0.35x zoom-out used by wall view).
        // Dividing the two only produced the correct model height by
        // coincidence in sticker view; in wall view it inflated
        // canvasHeight by roughly 1/0.35 (~2.85x), pushing new text far
        // below the visible canvas - looking like text "isn't zoomed out"
        // with everything else / renders below the canvas. Using the
        // fixed canvas_height constant keeps text positioned correctly
        // in model space regardless of which view (sticker or wall) is
        // currently active.
        const canvasHeight = canvas_height;
        //const canvasHeight = canvas.getHeight() / canvas.viewportTransform[3];
        /*KP - Mobile screen masurement text display in position */
        const isMobile = window.innerWidth <= 767;
        /*KP - Mobile screen masurement text display in position */

        // KP FEATURE - default photo+text layout: if a photo is already
        // on the canvas, new text should start left-aligned to the
        // photo's left edge, directly underneath it, so the two elements
        // use the canvas space efficiently out of the box. This anchor
        // comes from the photo's own position, so it works the same way
        // on desktop and mobile (no screen-width-based guessing needed).
        // If there's no photo yet, fall back to the original default
        // position. Either way this is just the STARTING position - the
        // customer can still drag text or photo anywhere afterwards.
        const existingImage = canvas.getObjects().find(function (obj) {
            return obj.type === 'image';
        });

        // KP FEATURE - needed here (before baseLeft/baseTop) so the
        // "first text block" checks below - both the Image Size reset
        // and the fontSize fallback further down - can tell whether this
        // is truly the very first text block being added to the canvas.
        const previousTextObjects = canvas.getObjects().filter(function (obj) {
            return obj.type === 'i-text';
        });
        const isFirstTextBlock = previousTextObjects.length === 0;

        const gapBelowImage = cmToPixel(5); // small breathing room under the photo
        const gapFromLeft = cmToPixel(1);   // small breathing room from the left edge before text starts
        const gapBetweenTextBlocks = cmToPixel(1); // KP FIX - a little extra breathing room between stacked text blocks
        const gapFromTop = cmToPixel(1); // KP FEATURE - small breathing room from the top edge when text falls back to the top of the canvas (see "no room left" fallbacks below)

        let baseLeft, baseTop;
        if (existingImage) {
            //baseLeft = existingImage.left + gapFromLeft;
            baseLeft = isMobile ? 900 : 700; //text starting from left align
            baseTop = existingImage.top + existingImage.getScaledHeight() + gapBelowImage;
        } else {
            // No photo yet - original default position (a little below
            // canvas center).
            baseLeft = isMobile ? 900 : 700;
            baseTop = (canvasHeight / 2) + (canvasHeight / 6);

            // KP FEATURE - customer is typing their FIRST text block
            // before uploading a photo; zero out the Image Size slider
            // (#imagescale) and the Image height/width fields, so the
            // "Resize to fit your space" controls clearly show there's
            // no image yet, instead of leftover/demo values carrying
            // into a real order.
            if (isFirstTextBlock) {
                $('#imageheight, #imagewidth').val("0");
                imageScaleSlider.min = 0;
                imageScaleSlider.value = 0;
                imageScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) 0%, #3b3b3b 0%)`;
            }
        }

        // KP FEATURE - the first text block always starts at the normal
        // default size (textFontSize, ~5cm), even if #textSizeInput is
        // currently showing 0 (zeroed out because an image was added
        // before any text existed - see canvas_add_image()). Every
        // subsequent block still follows whatever #textSizeInput
        // currently shows (kept in sync with the last-edited text block
        // by updateTextInputs()), so "Add another line" continues to
        // match the previous line's size/format.
        // Create the text object
        const text = new fabric.IText(transformText, {
            left: baseLeft,
            fontFamily: fontFamilySelect.value,
            fontSize: isFirstTextBlock ? textFontSize : (parseInt(textSizeInput.value) || textFontSize),
            fill: textColorInput.value,
            fontWeight: boldCheckbox.checked ? 'bold' : 'normal',
            fontStyle: italicCheckbox.checked ? 'italic' : 'normal',
            underline: underlineCheckbox.checked,
            selectable: true,
            splitByGrapheme: true,
            // KP FIX - text should only be editable via the external
            // #bg_canvas_texttransform input field, not by double-clicking
            // the text directly on the canvas. `editable: false` disables
            // fabric.IText's built-in double-click-to-enter-editing
            // behaviour (and any other route into enterEditing()), while
            // leaving selecting/dragging/resizing untouched. The object
            // still works fine as a normal (non-editing) selectable object,
            // and canvas.on('mouse:down') above still syncs the input field
            // with the clicked text's current value.
            editable: false,
        });

        // KP FIX - "Add another line" should produce text at the same
        // height AND the same left starting edge as the text block
        // already on the canvas. fontSize alone isn't enough to
        // guarantee the height: if the previous text block was resized
        // afterwards (dragging a corner, the Text Height/Width fields,
        // or the scale slider), it ends up with a scaleX/scaleY
        // different from 1, which changes its actual rendered height
        // independently of fontSize. Copy the last text block's scale
        // onto this new one so the Text Height field matches what it
        // showed for the previous block.
        //
        // KP FIX - left position: previously only scaleX/scaleY were
        // copied, so every new block still started from the same fixed
        // baseLeft (700/900) regardless of where the previous block
        // actually ended up. That fixed baseLeft is only a STARTING
        // point though - keepTextInsideCanvasHorizontally() (below,
        // after wrapping) can shift a block off of it and re-center it
        // horizontally if, at that starting left, the wrapped text would
        // run past the right edge of the canvas. A large (e.g. 100%
        // scale) block is far more likely to trigger that re-center than
        // a smaller one, so the previous block and this new block could
        // end up re-centered differently and drift out of alignment -
        // exactly the "second big block starts slightly right of the
        // first" issue this was causing. Inheriting the previous block's
        // actual left (post any re-centering it may have needed) keeps
        // every block in the stack flush against the same left edge.
        if (previousTextObjects.length > 0) {
            const lastTextObject = previousTextObjects[previousTextObjects.length - 1];
            text.set({
                scaleX: lastTextObject.scaleX,
                scaleY: lastTextObject.scaleY,
                left: lastTextObject.left
            });
        }

        // Calculate the new top position, stacking additional text blocks
        // below whichever base anchor was picked above.
        //
        // KP FIX - this used to sum up the (scaled) height of every
        // existing text block into a running total, instead of looking at
        // where those blocks actually sit on the canvas right now. That
        // running total only matched reality by coincidence when no block
        // had ever been resized. As soon as an earlier text block was
        // enlarged (e.g. via the font-size slider) its real position no
        // longer matched what the running total assumed, so a newly
        // typed second block could land far past the bottom of the
        // canvas (or on top of the first block). That bad starting
        // position then failed the very next keystroke's overflow check
        // (willTextOverflowCanvas), reverting the input and showing the
        // "Text has reached the maximum size..." alert after only one
        // letter had been typed.
        //
        // Fix: measure the ACTUAL bottom edge of the existing text
        // blocks (obj.top + obj.getScaledHeight()) and stack the new
        // block just below the lowest one, with the usual gap. If that
        // spot doesn't leave room for the new block - whether because
        // the stack has simply filled the canvas, or an earlier block
        // was resized to cover most of it - switch to upward stacking
        // (see textStackDirection below) instead of overflowing past
        // the bottom or overlapping existing text.
        const textHeight = text.getScaledHeight();

        // KP FEATURE - two-phase stacking (see textStackDirection above):
        //
        // Phase "down" (default): anchor to the MOST RECENTLY ADDED text
        // block (last in canvas.getObjects() order), not the tallest/
        // lowest block found anywhere on the canvas, so each new block
        // simply continues stacking below wherever the previous one
        // actually ended up - text never overlaps.
        //
        // Phase "up": once a block has overflowed the bottom once, every
        // further block stacks ABOVE the previously added block instead -
        // no bounce back down.
        let newTop;
        if (previousTextObjects.length === 0) {
            // No existing text blocks yet - use the default anchor and
            // reset direction, so a fresh stack always starts by filling
            // downward again.
            newTop = baseTop;
            textStackDirection = 'down';

            // KP FEATURE - if a photo is already on the canvas and has
            // been sized up so far (e.g. scaled to 100%) that its own
            // bottom edge already leaves no room for this first text
            // block underneath it, baseTop (image bottom + gap) would
            // land past the bottom of the canvas, pushing the text off
            // altogether. In that case there's nowhere left to go below
            // the image, so fall back to placing this first text block
            // at the TOP of the canvas instead (it will sit over the
            // image), and start the stack in upward mode so any further
            // text added after this continues stacking above it rather
            // than immediately re-colliding with the image below.
            if (newTop + textHeight > canvasHeight) {
                newTop = gapFromTop;
                textStackDirection = 'up';
            }
        } else if (textStackDirection === 'up') {
            // Already in upward-stacking mode - place this block directly
            // above whichever block was added last (which, since we're
            // going upward, is currently the topmost block in the stack).
            const lastTextObj = previousTextObjects[previousTextObjects.length - 1];
            newTop = lastTextObj.top - gapBetweenTextBlocks - textHeight;

            if (newTop < 0) {
                // Canvas is now completely full - no room left above
                // either. Rather than letting the block go off the top
                // edge, pin it to the very top of the canvas and stay in
                // upward mode so later blocks keep trying to stack above
                // it (matching the "add text at the top of canvas" fallback
                // used everywhere else there's no room left).
                newTop = gapFromTop;
                textStackDirection = 'up';
            }
        } else {
            const lastTextObj = previousTextObjects[previousTextObjects.length - 1];
            const stackBottom = lastTextObj.top + lastTextObj.getScaledHeight();
            newTop = stackBottom + gapBetweenTextBlocks;

            if (newTop + textHeight > canvasHeight) {
                // Doesn't fit below the existing stack - switch to
                // upward-stacking mode from here on, and place this
                // block directly above the very FIRST text block added
                // to the canvas.
                textStackDirection = 'up';
                const firstTextObj = previousTextObjects[0];
                newTop = firstTextObj.top - gapBetweenTextBlocks - textHeight;

                if (newTop < 0) {
                    // The existing stack (e.g. a single text block scaled
                    // to fill the whole canvas at 100%) already starts at
                    // or near the top, so there's no room above it either.
                    // Fall back to the top of the canvas instead of a
                    // negative/off-canvas position.
                    newTop = gapFromTop;
                }
            }
        }

        // Add the text to the canvas
        canvas.add(text);

        // Set the top position for the text
        text.set('top', newTop);

        // Wrap text and update inputs
        const wrappedText = wrapCanvasText(transformText, canvas, text);
        text.set("text", wrappedText);
        keepTextInsideCanvasHorizontally(wrappedText, text);

        canvas.setActiveObject(text);
        updateTextInputs(text);
        canvas.renderAll();

        // KP FIX - fonts load lazily (see ensureFontReady); re-render once
        // the text's font family/weight/style is actually downloaded so the
        // canvas never stays on the fallback font.
        ensureFontReady(
            fontFamilySelect.value,
            boldCheckbox.checked ? '700' : '400',
            italicCheckbox.checked ? 'italic' : 'normal'
        ).then(function () {
            canvas.renderAll();
        });
    }

    // KP FIX - text overflow guard: remembers the last input value that
    // did NOT overflow the canvas, so we can revert to it when a keystroke
    // (or paste) would push the text box below the bottom of the canvas.
    var lastValidTransformText = "";

    // Measures how tall a given (already-wrapped, i.e. containing "\n"
    // line breaks) string would render at, using the same font settings
    // as textObject, WITHOUT touching the real canvas object. fabric.Text
    // computes its own width/height from font metrics as soon as it's
    // constructed, so this is safe to call purely for measurement.
    function measureWrappedTextHeight(wrappedText, textObject) {
        var measurer = new fabric.Text(wrappedText || " ", {
            fontFamily: textObject.fontFamily,
            fontSize: textObject.fontSize,
            fontWeight: textObject.fontWeight,
            fontStyle: textObject.fontStyle,
            lineHeight: textObject.lineHeight,
            charSpacing: textObject.charSpacing
        });
        return measurer.height;
    }

    // KP FIX - returns true if placing wrappedText into textObject (at its
    // current top position and scale) would make the text box extend
    // below the bottom edge of the canvas.
    function willTextOverflowCanvas(wrappedText, textObject) {
        var measuredHeight = measureWrappedTextHeight(wrappedText, textObject) * (textObject.scaleY || 1);
        var projectedBottom = (textObject.top || 0) + measuredHeight;
        return projectedBottom > canvas_height;
    }

    // Measures how wide a given (already-wrapped) string's widest line
    // would render, using the same font settings as textObject. Mirrors
    // measureWrappedTextHeight above but for width.
    function measureWrappedTextWidth(wrappedText, textObject) {
        var measurer = new fabric.Text(wrappedText || " ", {
            fontFamily: textObject.fontFamily,
            fontSize: textObject.fontSize,
            fontWeight: textObject.fontWeight,
            fontStyle: textObject.fontStyle,
            lineHeight: textObject.lineHeight,
            charSpacing: textObject.charSpacing
        });
        return measurer.width;
    }

    // KP FIX - typing text near a canvas edge used to just run the text
    // off the side (once the wrap check stopped incorrectly factoring in
    // the box's own position - see the wrapCanvasText fix above, position
    // was never supposed to affect wrapping). Now that wrapping is based
    // purely on the text's own width, a box already sitting close to the
    // right (or left) border can still end up wider than the remaining
    // space next to it. Rather than letting it hang off the canvas, if the
    // updated text would extend past either edge at the box's current
    // position, re-center it horizontally so it always stays fully inside
    // the printable area.
    
    // function keepTextInsideCanvasHorizontally(wrappedText, textObject) {
    //     // KP FIX (mobile) - read the width straight off the real
    //     // textObject instead of measuring a separate throwaway
    //     // fabric.Text instance. By this point textObject already has
    //     // .set("text", wrappedText) applied, so its .width is already
    //     // up to date with whatever font is ACTUALLY rendering right now.
    //     // The old separate measurer could disagree with the real object
    //     // on mobile if the custom Google Font hadn't finished loading
    //     // yet at that exact moment (lazy-loaded on first font-dropdown
    //     // open, see selectBtn click handler) - the two would fall back
    //     // to different default fonts for a split second and get
    //     // different widths for the same string, which silently broke
    //     // this overflow check on slower/mobile devices.
    //     textObject.setCoords();
    //     var measuredWidth = textObject.width * (textObject.scaleX || 1);
    //     var left = textObject.left || 0;
    //     var projectedRight = left + measuredWidth;

    //     if (projectedRight > canvas_width || left < 0) {
    //         textObject.set('left', Math.max(0, (canvas_width - measuredWidth) / 2));
    //         textObject.setCoords();
    //         // KP FIX (mobile) - force an immediate repaint instead of
    //         // relying solely on the caller's later canvas.renderAll(),
    //         // so the corrected position is guaranteed to show up even
    //         // if something else in the input handler chain is slow to
    //         // re-render on a touch device.
    //         canvas.requestRenderAll();
    //     }
    // }

    function keepTextInsideCanvasHorizontally(wrappedText, textObject) {

        textObject.setCoords();

        var measuredWidth =
            textObject.width * (textObject.scaleX || 1);

        // Text itself is equal to/larger than canvas width
        if (measuredWidth >= canvas_width) {
            textObject.set({
                left: 0
            });
        } else {

            var left = textObject.left || 0;
            var projectedRight = left + measuredWidth;

            // Only reposition when going outside canvas
            if (left < 0 || projectedRight > canvas_width) {
                textObject.set({
                    left: (canvas_width - measuredWidth) / 2
                });
            }
        }

        textObject.setCoords();
        canvas.requestRenderAll();
    }



    function wrapCanvasText(text, canvas, textObject) {
    const context = canvas.getContext("2d");

    // KP FIX - context.font must include fontStyle and fontWeight, not
    // just size/family. Canvas2D's measureText() falls back to
    // "normal"/400 weight for any part of the font shorthand that's
    // omitted, so a bold textObject (e.g. bold Poppins) was being
    // measured at its NORMAL (narrower) width here while actually
    // rendering bold (wider) on the canvas. That let lines that were
    // really too wide pass the maxWidth check below and overflow past
    // the right edge of the canvas whenever bold was on - even though
    // resizing via #textSizeInput looked fine, because that path reads
    // width straight off the real fabric object (which fabric measures
    // using the correct weight internally) instead of rebuilding a
    // canvas font string by hand.
    const fontStyle = textObject.fontStyle === 'italic' ? 'italic' : 'normal';
    const fontWeight = textObject.fontWeight || 'normal';
    context.font = `${fontStyle} ${fontWeight} ${textObject.fontSize}px ${textObject.fontFamily}`;

    let formatted = '';
    let line = '';

    // Canvas logical width = 100cm
    const maxWidth = canvas_width;

    for (let i = 0; i < text.length; i++) {

        const testLine = line + text[i];

        const lineWidth =
            context.measureText(testLine).width *
            (textObject.scaleX || 1);

        // Allow text to use the FULL 100cm canvas width.
        if (lineWidth > maxWidth && line !== '') {

            formatted += line + '\n';

            // Current character starts the next line
            line = text[i];

        } else {

            line = testLine;
        }
    }

    formatted += line;

    return formatted.trim();
}

    // function wrapCanvasText(text, canvas, textObject) {
    //     const context = canvas.getContext("2d");

    //     // Use the font settings to match the text object
    //     context.font = `${textObject.fontSize}px ${textObject.fontFamily}`;

    //     let formatted = '';
    //     let line = '';

    //     for (let i = 0; i < text.length; i++) {
    //         line += text[i];
    //         // KP FIX - textObject.left is the box's X POSITION on the
    //         // canvas, not part of its width. Adding it here made the
    //         // "is this line too wide" check depend on where the text box
    //         // happened to sit (and get re-scaled by scaleX along with it),
    //         // so a box placed further right - or scaled down small, like a
    //         // narrow 3cm-wide sticker - would falsely register even a
    //         // single character as overflowing, wrapping one letter per
    //         // line. Only the rendered text width matters here.
    //         const lineWidth = context.measureText(line).width * textObject.scaleX;
    //         if (pixelsToCentimeters(lineWidth) >= 100) {
    //             // If the current line exceeds the max width, add the line to formatted text
    //             formatted += line.slice(0, -1) + '\n'; // Add hyphen for broken word
    //             line = text[i]; // Start a new line with the current character
    //         }
    //     }

    //     // Add any remaining characters
    //     formatted += line;

    //     return formatted.trim();
    // }

    /*document.getElementById('deactivateButton').addEventListener('click', function () {
        var activeObject = canvas.getActiveObject();

        if (activeObject && activeObject.type == "i-text") {
            $('#bg_canvas_texttransform').val("");
            lastValidTransformText = "";
            resetTextData();
            canvas.discardActiveObject();
            canvas.renderAll();
        }
    });*/

    document.getElementById('addanotherline').addEventListener('click', function () {
        var activeObject = canvas.getActiveObject();
        $('#bg_canvas_texttransform').attr('placeholder', '');

        if (activeObject && activeObject.type == "i-text") {
            $('#bg_canvas_texttransform').val("");
            lastValidTransformText = "";
            //resetTextData();
            canvas.discardActiveObject();
            canvas.renderAll();
        }
    });
    

    function resetTextData() {
        // Update input controls with the selected textbox properties
        // KP FIX - don't force the font family back to a default
        // here. Colour already isn't reset (line below is intentionally
        // left commented out) so a chosen colour carries over to the
        // next text added; font family should behave the same way and
        // keep whatever the customer last picked.
        // KP FIX - same reasoning applies to font size: don't reset it
        // back to the default textFontSize here, so the last font size
        // the customer chose carries over to the next text block too,
        // exactly like colour and font family already do.
        //textSizeInput.value = parseInt(textFontSize);
        let progress = (textScaleSlider.value / textScaleSlider.max) * 100;
        textScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${progress}%, #3b3b3b ${progress}%)`;
        //textColorInput.value = "#000000";
        //$('.bgColorPicker-container .clr-field').css('color', "#000000");
        boldCheckbox.checked = false;
        italicCheckbox.checked = false;
        underlineCheckbox.checked = false;
    }

  // ponytail: injects the google-fonts stylesheet once, resolves when the
  // @font-face rules are available. Injecting alone downloads no font
  // files (unicode-range subsets load lazily) - the editor stays light
  // until a font is actually requested via document.fonts.load().
  function injectFontCSS() {
      if (window._googleFontsCSSPromise) {
          return window._googleFontsCSSPromise;
      }
      var link = document.createElement('link');
      link.href = '//inspirewallsticker.com/cdn/shop/t/39/assets/google-fonts.css?v=155036345737869894441787575574';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
      window._googleFontsCSSPromise = new Promise(function (resolve) {
          link.onload = resolve;
          link.onerror = resolve;
      });
      return window._googleFontsCSSPromise;
  }

  // ponytail: guarantees the given family/weight/style is downloaded and
  // ready before the canvas is redrawn with it.
  function ensureFontReady(family, weight, style) {
      return injectFontCSS().then(function () {
          if (!document.fonts || !document.fonts.load) {
              return;
          }
          var str = (style === 'italic' ? 'italic ' : '') + (weight || '400') + ' 16px "' + family + '"';
          return document.fonts.load(str);
      });
  }

  // ponytail: batch-loads all editor fonts on first dropdown open instead
  // of on page load. The batch only starts once the stylesheet has been
  // parsed, so the document.fonts.load() calls below actually find the
  // @font-face rules and download the files.
  function ensureGoogleFontsLoaded() {
      if (window._googleFontsLoadedPromise) {
          return window._googleFontsLoadedPromise;
      }
    //   var loader = document.querySelector('.bg-loader');
    //   if (loader) loader.style.display = '';
      window._googleFontsLoadedPromise = injectFontCSS().then(function () {
          var loads = [];
          if (document.fonts && document.fonts.load) {
              Array.prototype.forEach.call(fontFamilySelect.options, function (opt) {
                  var fam = opt.value;
                  if (!fam) return;
                  loads.push(document.fonts.load('400 16px "' + fam + '"'));
                  var support = fontStyleSupport[fam] || { bold: true };
                  if (support.bold) {
                      loads.push(document.fonts.load('700 16px "' + fam + '"'));
                  }
              });
          }
          return Promise.all(loads);
      }).then(function () {
          canvas.renderAll();
        //   if (loader) loader.style.display = 'none';
      });
      return window._googleFontsLoadedPromise;
  }

  selectBtn.addEventListener("click", function () {
      // Previews are SVGs, so opening the dropdown no longer needs to
      // download every web font. A font loads only when it is selected
      // (see ensureFontReady in updateTextProperties).
      optionMenu.classList.toggle("active");
    });

    // KP - Close dropdown when clicking outside Start
    document.addEventListener("click", (event) => {
        if (!optionMenu.contains(event.target) && !selectBtn.contains(event.target)) {
            optionMenu.classList.remove("active");
        }
    });
    // KP - Close dropdown when clicking outside end

    options.forEach((option) => {
      option.addEventListener("click", () => {
        // Works for both <img> (SVG) options and the text <span> options
        // (extra fonts): read the font from the value attribute, never from
        // the element's text. The button always shows the name as text.
        const rawValue = option.querySelector(".option-text").getAttribute("value");
        const matched = resolveFontOption(rawValue);
        const fontValue = matched ? matched.value : rawValue;
        sBtn_text.innerText = getFontDisplayName(fontValue);

        let event = new Event("change");
        fontFamilySelect.value = fontValue;
        fontFamilySelect.dispatchEvent(event);

        optionMenu.classList.remove("active");
      });
    });

    /*KP make the example preview clickable to upload */
    $('#example-btn').on('click', function(e){
        e.preventDefault();
        // Open file picker
        $('#singleImageUpload').trigger('click');

    });
    /*KP make the example preview clickable to upload */

     // canvas scale on toggle view
    function canvasHasContent() {
        return canvas.getObjects().length > 0;
    }

    // Base "fit to container" scale — same scale resizeCanvas() uses to
    // map the 100cm logical canvas onto the actual (small) canvas element.
    // All view-toggle zoom levels must be relative to this, not absolute
    // numbers, otherwise objects positioned in the large cm-based
    // coordinate space fall outside the visible viewport.
    function getBaseScale() {
        var container = document.querySelector('.bg-canvas-holder');
        var containerWidth = container ? container.offsetWidth : canvas_width;
        if (!containerWidth) {
            containerWidth = canvas_width;
        }
        return containerWidth / canvas_width;
    }

    // KP FIX - wall view zooms the canvas OUT to ~0.3x of sticker view's
    // zoom (see showWallView() below: `getBaseScale() * 0.3`) so more of
    // the room photo is visible. The custom control icons (rotate /
    // delete / resize) and the width/height dimension lines + "Xcm"
    // labels are drawn in raw screen-pixel space at a FIXED size (see
    // renderIcon() and addWidthDimentionControls()/
    // addHeightDimentionControls() further down) - that fixed size looks
    // right in sticker view (zoom === getBaseScale()) but stays exactly
    // the same in wall view even though the object itself has shrunk to
    // ~0.3x on screen, making the icons/lines/labels look oversized
    // relative to the object.
    //
    // This returns how far the CURRENT view is zoomed out relative to
    // sticker view (1 in sticker view, ~0.3 in wall view). Every
    // fixed-pixel control size can be multiplied by this so it shrinks
    // in the same proportion as the object. Clamped to a sensible floor
    // so controls never shrink to an unusable/invisible size if a future
    // view zooms out even further than wall view's 0.3x.
    function getViewScaleRatio() {
        var currentZoom = (canvas.viewportTransform && canvas.viewportTransform[0]) ? canvas.viewportTransform[0] : 1;
        var stickerZoom = getBaseScale();
        if (!stickerZoom) {
            return 1;
        }
        var ratio = currentZoom / stickerZoom;
        return Math.min(Math.max(ratio, 0.6), 1);
    }

    // Applies a zoom level to the canvas while keeping the logical
    // (cm-based) content centered inside the actual canvas element.
    // Without this, zooming out (e.g. wall view) leaves the content
    // pinned to the top-left instead of centered in the visible area.
    // `verticalOffsetRatio` (optional) nudges the content up (positive
    // value) or down (negative value) by that fraction of the container
    // height, on top of the normal vertical centering - used by
    // showWallView() to keep the sticker clear of the sofa in the room
    // photo.
    function applyCenteredZoom(zoom, verticalOffsetRatio) {
        var canvasWidth = canvas.getWidth();
        var canvasHeight = canvas.getHeight();

        var tx = (canvasWidth - (canvas_width * zoom)) / 2;
        var ty = (canvasHeight - (canvas_height * zoom)) / 2;

        if (verticalOffsetRatio) {
            ty -= canvasHeight * verticalOffsetRatio;
        }

        canvas.setViewportTransform([
            zoom,
            0,
            0,
            zoom,
            tx,
            ty
        ]);

        canvas.requestRenderAll();
    }

    // KP FIX - the wall-view / sticker-view / page-started-wall-view CSS
    // classes on .bg-canvas-holder change its actual on-screen size
    // (aspect ratio), but the underlying <canvas> element's own
    // width/height (canvas.getWidth()/getHeight(), used above for both
    // getBaseScale() and applyCenteredZoom()'s centering math) only ever
    // get updated by resizeCanvas() on window resize / initial load.
    // Toggling views never resynced them, so after switching e.g. wall
    // view -> sticker view, the zoom/centering was computed against a
    // stale canvas size that no longer matched the new container -
    // making images/text appear cut off or not fit. This resyncs the
    // canvas element to the container's current size before we compute
    // or apply any view-toggle zoom.
    function syncCanvasToContainer() {
        var container = document.querySelector('.bg-canvas-holder');
        var containerWidth = container ? container.offsetWidth : canvas_width;
        if (!containerWidth) {
            containerWidth = canvas_width;
        }
        canvas.setDimensions({ width: containerWidth, height: containerWidth });
    }

    function showWallView() {

        // Resync first so getBaseScale()/applyCenteredZoom() measure the
        // container as it actually looks in wall view, not a stale size
        // left over from whatever view was active before.
        syncCanvasToContainer();

        // show more area (zoomed OUT relative to the normal/sticker fit)
        const zoom = getBaseScale() * 0.4;

         // shift the canvas up a bit so the sticker doesn't sit on/overlap
        // the sofa in the room photo. Increase this number to move it up
        // further, decrease (or set to 0) to move it back down.
        applyCenteredZoom(zoom, 0.10);
    }

    function showStickerView() {

        // Resync first - see syncCanvasToContainer() above.
        syncCanvasToContainer();

        // 100% = the normal fit-to-container scale (matches how the
        // image was centered/scaled when it was uploaded)
        const zoom = getBaseScale();

        applyCenteredZoom(zoom);
    }
    // canvas scale on toggle view

     
    // wall view / sofa view toggle
        
    // jQuery('#wall-view-btn').on('click', function () {
    //      // KP FIX - toggle the CSS classes FIRST. .bg-canvas-holder's
    //      // on-screen size depends on which of these classes is applied,
    //      // and showWallView() measures that size (via getBaseScale() /
    //      // syncCanvasToContainer()) to compute the zoom. Measuring before
    //      // the class switch used the OLD view's size, so the new view's
    //      // content didn't fit right after switching.
    //      var canvas_class = jQuery('.bg-canvas-holder');
     
    //      // If page-started-wall-view exists, use it instead of wall-view
    //      if (canvas_class.hasClass('no-upload-image')) {
    //         jQuery('.canvas-editor-note').removeClass('hidden');
    //          canvas_class.removeClass('sticker-view').addClass('page-started-wall-view');
    //      } else {
    //          canvas_class.removeClass('sticker-view').addClass('wall-view');
    //      }

    //       jQuery('.canvas-sticker-note').addClass('hidden');
    //        /*Temporary image add class  in sticker*/
    //          $(".bg-editor-canvas").removeClass("sticker-no-image-upload");
    //         /*Temporary image add class  in sticker*/
    //      showWallView();
     
    //      jQuery('.canvas-view-toggle-wrap .togglebtn').removeClass('active');
    //      jQuery(this).addClass('active');
    //  });
     
     // jQuery('#sticker-view-btn').on('click', function () {
     //     // KP FIX - same reordering as #wall-view-btn above: classes
     //     // before measuring/zooming.
     //     var canvas_class = jQuery('.bg-canvas-holder');
     
     //     // Remove both possible wall classes and add sticker-view
     //     canvas_class.removeClass('wall-view page-started-wall-view')
     //            .addClass('sticker-view');

     //     showStickerView();
     //      jQuery('.canvas-sticker-note').removeClass('hidden');
     //     jQuery('.canvas-editor-note').addClass('hidden');
     //     jQuery('.canvas-view-toggle-wrap .togglebtn').removeClass('active');
     //     jQuery(this).addClass('active');
     //      /*Temporary image add class  in sticker*/
     //     $(".bg-editor-canvas").removeClass("sticker-no-image-upload");
     //    /*Temporary image add class  in sticker*/

     // });

     // wall view / sofa view toggle end

})(jQuery);

document.addEventListener('click', function (e) {
    if (e.target.matches('.bgColorPicker')) {
        setTimeout(() => {
            const hexInput = document.querySelector('.clr-picker input[type="text"]');
            if (hexInput) {
                hexInput.blur();
            }
        }, 50);
    }
});